import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffTwoTone';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnTwoTone';
import PlaybackSpeed from '@mui/icons-material/ScheduleOutlined';
import PauseIcon from '@mui/icons-material/PauseCircleOutlined';
import { Box, Stack, Popper, Slider as MuiSlider } from '@mui/material';
import MuteIcon from '@mui/icons-material/VolumeMuteRounded';
import VolumeIcon from '@mui/icons-material/VolumeUpRounded';
import CenterLine from '@mui/icons-material/HorizontalRule';
import { useSnackbar } from 'material-ui-snackbar-provider';
import AddClipIcon from '@mui/icons-material/AddRounded';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useHotkeys } from 'react-hotkeys-hook';
import Draggable from 'react-draggable';

import { FavouriteChange, useClipFavourites, useFavouriteEditor } from '../ClipFavourites/context';
import { useSidebarPlayback } from '../ClipFavourites/useSidebarPlayback';
import { useDrawingMarkers } from '../VideoDrawing/context';
import { FavouriteStar } from '../ClipFavourites/Star';
import { useClipFilter } from '../ClipFilter/context';
import { FilterToolbarButton, FilterSummary } from '../ClipFilter/Panel';
// import Chrome, { ChromeInputType } from '@uiw/react-color-chrome';
import { ChromePicker } from 'react-color';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ExpandMoreIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessIcon from '@mui/icons-material/ExpandLessRounded';
import UndoIcon from '@mui/icons-material/KeyboardBackspace';
import FullScreen from '@mui/icons-material/ZoomOutMap';
import UploadJsonIcon from '@mui/icons-material/North';
import useDraggableScroll from 'use-draggable-scroll';
import { isHotkeyPressed } from 'react-hotkeys-hook';
import Locate from '@mui/icons-material/MyLocation';
import { useOnClickOutside } from 'usehooks-ts';
import { makeStyles } from '@material-ui/core';
import { enqueueSnackbar } from 'notistack';
import { Resizable } from 're-resizable';
import ReactSlider from 'react-slider';
import cx from 'classnames';
import { useHistory } from 'react-router-dom';

import {
  setShowSpeedOption,
  toFollowPlayhead,
  updateNotificationTrigger,
  updateSecondaySelectedClips,
  updateOrderedSecondarySelectedClips,
  updateShowNotes,
  updateTriggerToScroll,
} from '../../store/sharedStore/sharedStoreSlice';
import { COLLABORATIVE_FOLDER_TYPE, STATUS, VIDEOFEED, NOTIFICATION, TOPIC, CLIP, VIDEOFEED_TYPE } from '../../enums';
import { ReactComponent as DownloadIcon } from '../../assets/icons/pure-download.svg';
import { ReactComponent as SendIcon } from '../../assets/icons/sendClipsIcon.svg';
import { ReactComponent as ZoomOutIcon } from '../../assets/icons/zoom-out.svg';
import { ReactComponent as ZoomInIcon } from '../../assets/icons/zoom-in.svg';
import { TimelineRowDescription } from './TimelineRow/TimelineRowDescription';
import { detectMostCommonRowColor } from '../../helpers/mostCommonRowColor';
import DownloadDataModal from '../modules/VideoFileList/DownloadDataModal';
import { ReactComponent as PlayIcon } from '../../assets/icons/play.svg';
import { findOverlapBoundary, TimelineRow, TRow } from './TimelineRow';
import { ContainedButton, OutlinedButton } from '../modules/Buttons';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import VideoQualitySelector from '../modules/VideoQualitySelector';
import {
  findSearchValue,
  getComposerWebPreferences,
  parseColorToHex,
  rememberManualVolumeOverrideForFeed,
  useDimensions,
} from '../../helpers';
import CreateOrSendModal from '../Composer/CreateOrSendModal';
import { useAutoRepeat } from '../../helpers/useAutoRepeat';
import UploadJsonModal from '../VideoPage/UploadJsonModal';
import { ACCESS_TYPE_ENUM } from '../../enums/ACCESS_ENUM';
import { SortOptions, SortType } from '../../enums/SORT';
import { addZeroToNumber, convertSeconds, getSelectedPlaybackClip } from './utils';
import hexToNormalizedRGB from '../../helpers/hexToRGB';
import LinearProgress from '../modules/LinearProgress';
import rgbToHex from '../../helpers/RGBToHex.helpers';
import { TimelineButton } from './TimelineButton';
import NewComposerModal from './NewComposerModal';
import CreateRowModal from './CreateRowModal';
import SendClipModal from './SendClipModal';
import styles from './Timeline.module.scss';
import CopyLinkModal from './CopyLinkModal';
import CreateEmptyTimelineModal from '../modules/CreateEmptyTimelineModal';
import { TimeMarks } from './TimelineMark';
import { TClip } from './TimelineClip';
import GeneratedMoviesWarningModal from '../modules/GeneratedMoviesWarningModal';
import MobileControlCenter from '../modules/MobileControlCenter';
import { RolesLowerCase } from '../../enums/ROLES';
import {
  createClipForTopic,
  createComposerTopic,
  editClip,
  setClipAngleLock,
  estimateComposerDownload,
  getComposerDataByVideoFeedIdForTimelineRow,
  getFolderById,
  patchReoderComposer,
  postCreateEmptyTimeline,
  removeClipForTopic,
  removeTopic,
  updateTopicName,
} from '../../api';
import {
  triggerRefresh,
  updateTimelineSeconds,
  updateVideoControls,
  updateVideoPlayedSeconds,
  updateQualifiers,
  updateNotes,
  saveCurrentPlayingTimelineClip,
  updateTimelineClipAngleLock,
  imperativeMarkerSetter,
  updateMarkerPosition,
  updateSortedSelectedClips,
  updateReachedEnd,
  updatePlayThisClip,
  playNextClipInOrder,
  playPreviousClipInOrder,
  TimelineTClip,
  getAllContentVideofeedsThunk,
  getAllSharedVideoFeedsByFolderId,
  getAllVideoFeedsByFolderId,
} from '../../store/videos/videoSlice';

const useStyles = makeStyles({
  slider: { width: '100%', height: '14px', background: 'transparent' },
  thumb: (props: any) => ({
    width: 3,
    height: 14,
    borderRadius: 2,
    top: -13,
    transform: 'translateY(0)',
    marginTop: 15,
    marginLeft: 0,
    border: 'none',
    outline: 'none',
    '&:focus': {
      outline: 'none', // ⬅ remove focus outline
    },
    '&:before': {
      content: '" "',
      position: 'absolute',
      top: 0,
      width: 3,
      height: `${props.markerHeight - 5}px`,
      backgroundColor: '#6500aa',
      borderRadius: 2,
      boxShadow: '0 0 5px rgba(0,0,0,0.5)',
      left: 0,
    },
    '&:after': {
      content: '" "',
      width: 15,
      height: 15,
      backgroundColor: '#6500aa',
      borderRadius: '50%',
      position: 'absolute',
      top: -12,
      boxShadow: '0 0 3px rgba(0,0,0,0.5)',
      left: -6,
      right: 0,
    },
  }),
  track: { opacity: 1, height: '18px', zIndex: 999, background: 'transparent', top: -5 },
  rail: { opacity: 1, height: '18px', zIndex: 999, background: 'transparent', top: -5 },
});

type Props = {
  value: number;
  max: number;
  width: number;
  markerHeight: number;
  onChange: (e: any, v: number | number[]) => void;
};

export const CustomSlider: React.FC<Props> = ({ value, max, width, markerHeight, onChange }) => {
  const classes = useStyles({ markerHeight });
  const sliderRef = useRef<ReactSlider>(null);
  useLayoutEffect(() => { sliderRef.current?.resize(); }, [width, max]);
  const handleChange = (v: number | number[]) => {
    onChange(null, v);
  };

  return (
    <ReactSlider
      ref={sliderRef}
      min={0}
      max={max}
      step={0.1}
      value={value}
      onChange={handleChange}
      className={classes.slider}
      thumbClassName={classes.thumb}
      renderThumb={(props) => <div {...props} className={classes.thumb} data-preserve-clip-edit />}
      renderTrack={(props, state) => (
        <div {...props} className={state.index === 0 ? classes.rail : classes.track} data-preserve-clip-edit />
      )}
    />
  );
};

const MIN_ZOOM = 1;
const ZOOM_EPS = 0.001;
const ignoreSendClipShortcut = (event: KeyboardEvent) =>
  Boolean(
    document.getElementById('clip-drawer-modal') ||
      (event.target as HTMLElement | null)?.closest('[role="dialog"]'),
  );
const MOBILE_WIDTH_BREAKPOINT = 768;
const DEFAULT_ROW_NAME_WIDTH = 250;
const DEFAULT_NAME_WIDTH = 200;
const MOBILE_ROW_NAME_WIDTH = 108;
const MOBILE_NAME_WIDTH = 96;
const DESKTOP_SIDEBAR_MIN_WIDTH = 200;
const DESKTOP_SIDEBAR_MAX_WIDTH = 500;
const MOBILE_SIDEBAR_MIN_WIDTH = 92;
const MOBILE_SIDEBAR_MAX_WIDTH = 120;
const DESKTOP_NAME_WIDTH_OFFSET = 90;
const MOBILE_NAME_WIDTH_OFFSET = 14;

const getInitialTimelineSidebarWidth = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_ROW_NAME_WIDTH;
  }
  return window.innerWidth < MOBILE_WIDTH_BREAKPOINT ? MOBILE_ROW_NAME_WIDTH : DEFAULT_ROW_NAME_WIDTH;
};

const getInitialTimelineNameWidth = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_NAME_WIDTH;
  }
  return window.innerWidth < MOBILE_WIDTH_BREAKPOINT ? MOBILE_NAME_WIDTH : DEFAULT_NAME_WIDTH;
};

export const formatSeconds = (sec: number) => {
  if (sec < 3600) {
    const m = Math.floor(sec / 60).toFixed(0);
    const s = (sec % 60).toFixed(0);
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  } else {
    const h = Math.floor(sec / 3600).toFixed(0);
    const m = Math.floor((sec % 3600) / 60).toFixed(0);
    const s = (sec % 60).toFixed(0);
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }
};

export type TSelectedClip = {
  rowIndex: number;
  start: number;
  name: string;
  end: number;
};

export type TTimelineSession = {
  favourite?: FavouriteChange;
  clip?: {
    id: string;
    status: string;
    time_start: string;
    time_end: string;
    color: string;
    topicId: any;
  };
  topic?: {
    id: any;
    name: string;
    topicIndex?: number;
    clips?: CLIP[];
    status: string;
    topicDetails?: {
      id: string;
      uuid: string;
      category?: string;
      color?: string;
    };
    previousOrder?: string[];
    previousMarkerPosition?: {
      rowIndex: number;
      clipIndex: number;
    };
  };
};

const buildReorderPayload = (rows: TRow[]) => ({
  topics: rows.map((row) => ({
    id: row.id,
    clips: row.clips.map((clip, clipIndex) => ({
      id: clip.id,
      clipIndex,
    })),
  })),
});

type TRowDragState = {
  dragging: boolean;
  rowId?: string;
  startIndex?: number;
  targetIndex?: number;
};

type TTimeline = {
  collapsed: boolean;
  toolbarHidden?: boolean;
  onToggleCollapse: () => void;
  userAccess: ACCESS_TYPE_ENUM | 'idle';
  videoPlayerHeight: number;
  videoRows: TRow[];
  fullScreen: any;
  fetchData: (forJson?: boolean) => Promise<any>;
  feedData: VIDEOFEED | null;
  setVideoRows: React.Dispatch<React.SetStateAction<TRow[]>>;
  onAngleLockChange: (clipId: string, locked_angle_id: number | null) => void;
  onShowComments: () => void;
};

function isValidArg(arg: any) {
  // Check for null, undefined, or an empty string (after trimming)
  if (arg == null || (typeof arg === 'string' && arg.trim() === '')) {
    return false;
  }
  // Check if it's a React SyntheticEvent (which has a persist method)
  if (typeof arg.persist === 'function') {
    return false;
  }
  return true;
}

const DEFAULT_MARK_MARGIN = 30;
const compareTimelineClips = (a: TClip, b: TClip) =>
  a.time_start - b.time_start || (a.rowIndex ?? 0) - (b.rowIndex ?? 0) || (a.clipIndex ?? 0) - (b.clipIndex ?? 0);

const Timeline: React.FC<TTimeline> = ({
  collapsed,
  toolbarHidden,
  onToggleCollapse,
  videoRows,
  videoPlayerHeight,
  userAccess,
  fullScreen,
  fetchData,
  feedData,
  setVideoRows,
  onAngleLockChange,
  onShowComments,
}) => {
  const PAUSE_OVERLAY_HIDE_EVENT = 'amplify:hide-pause-overlay';
  const { notifySeek } = useDrawingMarkers();
  const { config: clipFilterConfig, active: clipFilterActive, dimmedIds, collapsedRowIds, shown: filteredClipCount, waitingForComments } = useClipFilter();
  const notifyHidePauseOverlay = () => {
    window.dispatchEvent(new CustomEvent(PAUSE_OVERLAY_HIDE_EVENT, { detail: { context: 'timeline' } }));
  };

  const [TIMELINE_MARK_MARGIN, setTimelineMarkMargin] = useState(30);
  const [zoom, setZoom] = useState(10);
  const [isZooming, setIsZooming] = useState(false);
  const zoomingResetTimerRef = useRef<number | null>(null);
  const zoomAnchorOffsetRef = useRef<number | null>(null);
  const zoomAnchorPendingRef = useRef(false);
  const [triggerForuseEffect, setTriggetForuseEffect] = useState(0);
  const { currentUser, myOrganization } = useAppSelector((state) => state.user);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [currentFeed, setCurrentFeed] = useState<VIDEOFEED>();
  const feedId = findSearchValue('feedId');
  const folderId = findSearchValue('folderId');
  const shared = findSearchValue('shared');
  const dispatch = useAppDispatch();
  const routerHistory = useHistory();
  const { widthD } = useDimensions();
  const isNarrowScreen = widthD < MOBILE_WIDTH_BREAKPOINT;
  const [isMobileControlCenterOpen, setIsMobileControlCenterOpen] = useState(true);
  const sidebarMinWidth = isNarrowScreen ? MOBILE_SIDEBAR_MIN_WIDTH : DESKTOP_SIDEBAR_MIN_WIDTH;
  const sidebarMaxWidth = isNarrowScreen ? MOBILE_SIDEBAR_MAX_WIDTH : DESKTOP_SIDEBAR_MAX_WIDTH;
  const nameWidthOffset = isNarrowScreen ? MOBILE_NAME_WIDTH_OFFSET : DESKTOP_NAME_WIDTH_OFFSET;
  const minNameWidth = isNarrowScreen ? 70 : 72;
  const acceptedGeneratedMoviesWarningRef = useRef<Partial<Record<string, boolean>>>({});
  const generatedMoviesWarningResolverRef = useRef<((accepted: boolean) => void) | null>(null);
  const [showGeneratedMoviesWarningModal, setShowGeneratedMoviesWarningModal] = useState(false);

  const resolveGeneratedMoviesWarningModal = useCallback((accepted: boolean) => {
    if (generatedMoviesWarningResolverRef.current) {
      generatedMoviesWarningResolverRef.current(accepted);
      generatedMoviesWarningResolverRef.current = null;
    }
    setShowGeneratedMoviesWarningModal(false);
  }, []);

  const requestGeneratedMoviesWarningConfirmation = useCallback((): Promise<boolean> => {
    if (generatedMoviesWarningResolverRef.current) {
      return Promise.resolve(false);
    }

    return new Promise<boolean>((resolve) => {
      generatedMoviesWarningResolverRef.current = resolve;
      setShowGeneratedMoviesWarningModal(true);
    });
  }, []);

  useEffect(
    () => () => {
      if (generatedMoviesWarningResolverRef.current) {
        generatedMoviesWarningResolverRef.current(false);
        generatedMoviesWarningResolverRef.current = null;
      }
    },
    [],
  );

  const ensureGeneratedMoviesWarningBeforeSending = useCallback(
    async (targetFeedId: string): Promise<boolean> => {
      const normalizedFeedId = String(targetFeedId || '');
      if (!normalizedFeedId) return true;

      if (acceptedGeneratedMoviesWarningRef.current[normalizedFeedId]) {
        return true;
      }

      try {
        const [standalone, standalonePadding] = await Promise.all([
          estimateComposerDownload(normalizedFeedId, { mode: 'angles' as any }),
          estimateComposerDownload(normalizedFeedId, { mode: 'anglesPaddingJson' as any }),
        ]);

        const getReusedOutputs = (response: any) => {
          const estimate = response?.data ?? response;
          const reusedOutputs = Number(estimate?.reusedOutputs ?? 0);
          return Number.isFinite(reusedOutputs) ? reusedOutputs : 0;
        };

        const hasGeneratedMovies = getReusedOutputs(standalone) > 0 || getReusedOutputs(standalonePadding) > 0;
        if (!hasGeneratedMovies) return true;
      } catch (error) {
        console.warn('Failed to check generated standalone movies', error);
        return true;
      }

      const accepted = await requestGeneratedMoviesWarningConfirmation();
      if (accepted) {
        acceptedGeneratedMoviesWarningRef.current[normalizedFeedId] = true;
      }
      return accepted;
    },
    [requestGeneratedMoviesWarningConfirmation],
  );

  const [parentFolder, setParentFolder] = useState<COLLABORATIVE_FOLDER_TYPE | null>();

  const fetchParentFolder = async () => {
    const res = await getFolderById(folderId!);
    if (res.data) {
      setParentFolder(res.data);
    }
  };

  useEffect(() => {
    if (folderId) {
      fetchParentFolder();
    }
  }, [folderId]);

  const getCurrentVideofeed = async (id: string | number) => {
    const res = await getComposerDataByVideoFeedIdForTimelineRow(String(id));
    if (res?.data) {
      setCurrentFeed(res.data);
    }
  };

  useEffect(() => {
    if (feedId) {
      getCurrentVideofeed(feedId);
      if (clipDrawer) {
        setClipDrawer(null);
      }
      setHasOverlap(false);
      setSession([]);
    }
  }, [feedId, triggerForuseEffect]);

  const [clipDrawer, setClipDrawer] = useState<{
    time_start: number;
    time_end: number;
    topicId: string;
    id?: string;
    color?: string;
    isEdit?: boolean;
  } | null>(null);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const {
    videoLength,
    currentPlayingTimelineClip,
    sortedSelectedClips,
    videoPlayedSeconds,
    storeSelectedClip,
    markerPosition,
    videoControls,
    playThisClip,
    reachedEnd,
    status,
  } = useAppSelector((state) => state.videoStore);
  const { showNotes, followPlayhead, showSpeedOption, selectedVideoQuality, isDraggingCursor, currentVideoThatInFrame } = useAppSelector((state) => state.sharedStore);
  const { undoFavourites, pending: favouritePending, workspace, setWorkspace, enterClip, playerSeek, actions } = useClipFavourites();
  const [undoingFavourite, setUndoingFavourite] = useState(false);
  const displayPlayedSeconds = videoControls.playing ? videoControls.playedSeconds : videoPlayedSeconds;
  const selectedFavouriteClips = useMemo(() => sortedSelectedClips.flatMap((clip) => {
    const current = videoRows[clip.rowIndex]?.clips.find((item) => item.id === clip.id);
    return current ? [current] : [];
  }), [videoRows, sortedSelectedClips]);
  const favouriteClipId = useMemo(() => {
    const marked = videoRows[markerPosition.rowIndex]?.clips[markerPosition.clipIndex];
    const containsPlayhead = (clip: TClip) => displayPlayedSeconds >= clip.time_start && displayPlayedSeconds <= clip.time_end;
    if (workspace === 'sidebar') return marked?.id;
    const selected = selectedFavouriteClips;
    if (!selected.length) return marked && containsPlayhead(marked) ? marked.id : undefined;
    if (marked && containsPlayhead(marked) && selected.some((clip) => clip.id === marked.id)) return marked.id;
    const distance = (clip: TClip) => Math.max(clip.time_start - displayPlayedSeconds, 0, displayPlayedSeconds - clip.time_end);
    return selected.reduce((nearest, clip) => distance(clip) < distance(nearest) ? clip : nearest).id;
  }, [videoRows, markerPosition, selectedFavouriteClips, displayPlayedSeconds, workspace]);
  const filteredNavigationClips = useMemo(() => {
    const clips: TimelineTClip[] = sortedSelectedClips.length ? sortedSelectedClips : videoRows.flatMap((row, rowIndex) =>
      row.clips.map((clip, clipIndex) => ({ ...clip, rowIndex, clipIndex, topicId: row.id, topicName: row.name })));
    return clips.filter((clip) => !dimmedIds.has(String(clip.id)) && clip.time_end > clip.time_start)
      .sort(compareTimelineClips);
  }, [sortedSelectedClips, videoRows, dimmedIds]);
  const seekFilteredClip = useCallback((clip: TimelineTClip) => {
    enterClip(clip.id);
    dispatch(updateReachedEnd(false));
    dispatch(updatePlayThisClip(null));
    dispatch(saveCurrentPlayingTimelineClip(clip));
    dispatch(updateVideoPlayedSeconds(clip.time_start));
    dispatch(updateTimelineSeconds(clip.time_start));
    dispatch(imperativeMarkerSetter({ seconds: clip.time_start, rowIndex: clip.rowIndex, clipIndex: clip.clipIndex }));
    dispatch(updateTriggerToScroll());
    dispatch(toFollowPlayhead(true));
    dispatch(triggerRefresh());
    playerSeek.current?.(clip.time_start);
  }, [dispatch, enterClip, playerSeek]);
  const stopFilteredPlayback = useCallback((seconds = videoControls.playedSeconds) => {
    dispatch(updateReachedEnd(true));
    dispatch(updateVideoControls({ ...videoControls, playing: false, playedSeconds: seconds }));
    dispatch(updateVideoPlayedSeconds(seconds));
    dispatch(updateTimelineSeconds(seconds));
  }, [dispatch, videoControls]);
  const markedClip = videoRows[markerPosition.rowIndex]?.clips[markerPosition.clipIndex];
  const advanceFilteredPlayback = useCallback(() => {
    if (!markedClip) { stopFilteredPlayback(); return; }
    const next = filteredNavigationClips.find((clip) => compareTimelineClips(clip, { ...markedClip, ...markerPosition }) > 0);
    if (next) seekFilteredClip(next);
    else stopFilteredPlayback(markedClip.time_end);
  }, [markedClip, markerPosition, filteredNavigationClips, seekFilteredClip, stopFilteredPlayback]);
  const handleFilteredTimelineEnded = useCallback((seconds: number) => {
    if (!videoControls.playing || videoControls.seeking || isDraggingCursor || clipDrawer || !markedClip || seconds < markedClip.time_end - 0.05) return;
    advanceFilteredPlayback();
  }, [videoControls.playing, videoControls.seeking, isDraggingCursor, clipDrawer, markedClip, advanceFilteredPlayback]);
  const sidebarPlayback = useSidebarPlayback({
    activeClip: videoRows[markerPosition.rowIndex]?.clips[markerPosition.clipIndex],
    seconds: displayPlayedSeconds,
    playing: videoControls.playing,
    seeking: isDraggingCursor || videoControls.seeking,
    onTimelineEnded: clipFilterActive ? handleFilteredTimelineEnded : undefined,
  });
  const previousFilteredPlayback = useRef({ id: markedClip?.id, seconds: displayPlayedSeconds, playing: videoControls.playing });
  const sortedSelectedClipsRef = useRef(sortedSelectedClips);
  const markerPositionRef = useRef(markerPosition);
  const videoControlsRef = useRef(videoControls);
  const playThisClipRef = useRef(playThisClip);

  useEffect(() => {
    sortedSelectedClipsRef.current = sortedSelectedClips;
  }, [sortedSelectedClips]);
  useEffect(() => {
    markerPositionRef.current = markerPosition;
  }, [markerPosition]);
  useEffect(() => {
    videoControlsRef.current = videoControls;
  }, [videoControls]);
  useEffect(() => {
    playThisClipRef.current = playThisClip;
  }, [playThisClip]);

  useEffect(() => {
    const handleArrowStep = (event: KeyboardEvent) => {
      if (videoControls.playing) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      const target = event.target as HTMLElement | null;
      if (target?.closest('[data-clip-filter-panel]')) return;
      const targetTag = target?.tagName?.toLowerCase();
      const isTypingTarget =
        targetTag === 'input' || targetTag === 'textarea' || Boolean((target as HTMLElement | null)?.isContentEditable);
      if (isTypingTarget) return;

      event.preventDefault();
      dispatch(toFollowPlayhead(true));
      notifyHidePauseOverlay();
    };

    window.addEventListener('keydown', handleArrowStep);
    return () => {
      window.removeEventListener('keydown', handleArrowStep);
    };
  }, [dispatch, videoControls.playing]);

  const switchNewComposerModal = useCallback(() => {
    setShowConfirmModal((prevShow) => {
      if (!prevShow && videoControls.playing) {
        dispatch(updateVideoControls({ ...videoControls, playing: false }));
        notifyHidePauseOverlay();
      }
      return !prevShow;
    });
  }, [dispatch, videoControls]);

  const onClipSelect = useCallback(
    (
      clip: TClip,
      topicId: string,
      rowIndex: number,
      clipIndex: number,
      topicName: string,
      onDoubleClick?: boolean,
      nextMenuOption?: boolean,
    ) => {
      const selectedClips = sortedSelectedClipsRef.current;
      const marker = markerPositionRef.current;
      const controls = videoControlsRef.current;
      const currentPlayThisClip = playThisClipRef.current;

      if (clipDrawer) {
        if (!nextMenuOption) {
          setClipDrawer(null);
        }
        dispatch(updateSortedSelectedClips([]));
        dispatch(updateSecondaySelectedClips([]));
      }
      let arr = isHotkeyPressed('Ctrl') || isHotkeyPressed('Meta') || isHotkeyPressed('Shift') ? [...selectedClips] : [];
      dispatch(updateReachedEnd(false));
      if (lastSelectedRow) {
        setLastSelectedRow('');
      }

      if (arr.find((c) => c.id === clip.id)) {
        // remove clip if it was already selected
        const indexOfClip = selectedClips.findIndex((c) => c.id === clip.id);
        arr = arr.filter((c) => c.id !== clip.id);

        if (marker.clipIndex === clipIndex && marker.rowIndex === rowIndex) {
          const nextIndex = indexOfClip === -1 || indexOfClip + 1 > selectedClips.length - 1 ? 0 : indexOfClip + 1;
          if (selectedClips[nextIndex] && arr.length) {
            if (controls.playing) {
              dispatch(
                updateMarkerPosition({
                  rowIndex: selectedClips[nextIndex].rowIndex,
                  clipIndex: selectedClips[nextIndex].clipIndex,
                }),
              );
              dispatch(updateVideoPlayedSeconds(selectedClips[nextIndex].time_start));
            } else {
              dispatch(updatePlayThisClip(selectedClips[indexOfClip]));
            }
          }
        }
      } else {
        // add clip to selectedArray
        enterClip(clip.id);
        dispatch(toFollowPlayhead(true));
        arr.push({ ...clip, rowIndex, clipIndex, topicName, topicId });
        if (controls.playedSeconds >= clip.time_start && controls.playedSeconds < clip.time_end && selectedClips.length === 0) {
          dispatch(updateMarkerPosition({ rowIndex, clipIndex }));
        } else {
          dispatch(updateVideoPlayedSeconds(clip.time_start));
          dispatch(
            imperativeMarkerSetter({
              seconds: clip.time_start,
              rowIndex,
              clipIndex,
            }),
          );
        }
        dispatch(saveCurrentPlayingTimelineClip({ ...clip, rowIndex, clipIndex, topicName, topicId }));
        if (currentPlayThisClip) dispatch(updatePlayThisClip(null));
      }

      const arrSortedByIndexes = JSON.parse(JSON.stringify(arr)) as TimelineTClip[];
      // sort clips

      arrSortedByIndexes.sort((a, b) => a.rowIndex! - b.rowIndex! || a.clipIndex! - b.clipIndex!);

      if (isHotkeyPressed('Shift')) {
        const firstClip = arrSortedByIndexes[0];
        const lastClip = arrSortedByIndexes[arrSortedByIndexes.length - 1];
        const selectedClips: TimelineTClip[] = [];

        for (let row = firstClip.rowIndex!; row <= lastClip.rowIndex!; row++) {
          const clipsInRow = videoRows[row].clips;
          const start = row === firstClip.rowIndex! ? firstClip.clipIndex! : 0;
          const end = row === lastClip.rowIndex! ? lastClip.clipIndex! : clipsInRow.length - 1;

          for (let ci = start; ci <= end; ci++) {
            const clip = clipsInRow[ci];
            selectedClips.push({
              ...clip,
              rowIndex: row,
              clipIndex: ci,
              topicId: videoRows[row].id,
              topicName: videoRows[row].name,
            });
          }
        }

        arr = selectedClips;
      }

      arr.sort((a, b) => {
        if (a.time_start === b.time_start) {
          return a.rowIndex! - b.rowIndex!;
        }
        return a.time_start - b.time_start;
      });

      const currentUrl = new URL(window.location.href);
      const searchParams = currentUrl.searchParams;
      const clipToJump = searchParams.get('clipToJump');
      if (clipToJump) {
        searchParams.set('clipToJump', clip.id);
        history.replaceState({}, '', currentUrl.toString());
      }

      dispatch(updateSortedSelectedClips(arr));

      if (onDoubleClick) {
        dispatch(updateVideoControls({ ...controls, playing: true }));
      }
      dispatch(triggerRefresh());
    },
    [videoRows, dispatch, enterClip],
  );

  const timelineRefSidebar = useRef<HTMLDivElement>(null);
  const videoLengthInSeconds: number = useMemo(() => {
    return videoLength / 1000;
  }, [videoLength]);

  const timelineWidth: number = useMemo(() => {
    const width = videoLengthInSeconds * (TIMELINE_MARK_MARGIN + 1);
    const zoomedWidth = width / zoom;
    return zoomedWidth + 1;
  }, [videoLengthInSeconds, zoom]);

  const ensureFollowPlayhead = useCallback(() => {
    if (!followPlayhead) {
      dispatch(toFollowPlayhead(true));
    }
  }, [dispatch, followPlayhead]);

  const [markMargin, setMarkMargin] = useState(DEFAULT_MARK_MARGIN);
  const zoomToFit = (duration = videoLengthInSeconds) => {
    const wrapper = divRef.current;
    const sidebar = timelineRefSidebar.current;
    if (!wrapper || !sidebar) return;
    const containerWidth = wrapper.clientWidth - sidebar.clientWidth - 19;
    const rawWidth = duration * (markMargin + 1);
    const newZoom = rawWidth / containerWidth;
    setZoom(parseFloat(newZoom.toFixed(2)));
    ensureFollowPlayhead();
    hadZoomToFitRef.current = true;
    lastFitZoomRef.current = parseFloat(newZoom.toFixed(2));
  };
  const zoomToFitRef = useRef(zoomToFit);
  zoomToFitRef.current = zoomToFit;

  const zoomToMax = () => {
    setZoom(MIN_ZOOM);
    setMarkMargin(DEFAULT_MARK_MARGIN);
    ensureFollowPlayhead();
  };

  const queueZoomAnchorToPlayhead = useCallback(() => {
    const timelineParentScroller = document.getElementById('timeline_parent_scroller');
    if (!timelineParentScroller) return;

    const currentZoomedMargin = (TIMELINE_MARK_MARGIN + 1) / zoom;
    const currentMarkerOffset = displayPlayedSeconds * currentZoomedMargin + 1;
    zoomAnchorOffsetRef.current = currentMarkerOffset - timelineParentScroller.scrollLeft;
    zoomAnchorPendingRef.current = true;
  }, [TIMELINE_MARK_MARGIN, zoom, displayPlayedSeconds]);

  const handleZoomOut = useCallback(() => {
    setIsZooming(true);
    if (zoomingResetTimerRef.current) {
      window.clearTimeout(zoomingResetTimerRef.current);
    }
    zoomingResetTimerRef.current = window.setTimeout(() => setIsZooming(false), 140);
    const wrapper = divRef.current;
    const sidebar = timelineRefSidebar.current;
    autoFitOnResizeRef.current = true;
    if (!wrapper || !sidebar) return;
    const containerWidth = wrapper.clientWidth - sidebar.clientWidth - 19;
    const rawWidth = videoLengthInSeconds * (markMargin + 1);
    const maxZoom = parseFloat((rawWidth / containerWidth).toFixed(2));
    const cap = lastFitZoomRef.current ?? maxZoom;
    if (zoom >= cap - ZOOM_EPS) return;
    queueZoomAnchorToPlayhead();
    setZoom((z) => (z >= cap - ZOOM_EPS ? z : Math.min(z * 2, cap)));
    ensureFollowPlayhead();
  }, [videoLengthInSeconds, markMargin, zoom, queueZoomAnchorToPlayhead, ensureFollowPlayhead]);

  // ensure right-click Zoom In still resets fully
  const handleZoomIn = useCallback(
    (e?: React.MouseEvent) => {
      setIsZooming(true);
      if (zoomingResetTimerRef.current) {
        window.clearTimeout(zoomingResetTimerRef.current);
      }
      zoomingResetTimerRef.current = window.setTimeout(() => setIsZooming(false), 140);
      if (e?.type === 'contextmenu') {
        if (zoom <= MIN_ZOOM + ZOOM_EPS) return;
        e.preventDefault();
        queueZoomAnchorToPlayhead();
        zoomToMax();
        return;
      }

      if (zoom <= MIN_ZOOM + ZOOM_EPS) return;
      if (hadZoomToFitRef.current) autoFitOnResizeRef.current = false;
      queueZoomAnchorToPlayhead();
      setZoom((z) => (z <= MIN_ZOOM + ZOOM_EPS ? z : Math.max(z / 2, MIN_ZOOM)));
      ensureFollowPlayhead();
    },
    [zoom, queueZoomAnchorToPlayhead, ensureFollowPlayhead],
  );

  useEffect(() => {
    return () => {
      if (zoomingResetTimerRef.current) {
        window.clearTimeout(zoomingResetTimerRef.current);
      }
    };
  }, []);

  const fittedFeedIdRef = useRef<string>();
  const zoomDebounceRef = useRef<number | null>(null); // debounce timer for zoom checks

  // Helper: if content width <= container width, force-fit
  const ensureFitIfLoose = useCallback(() => {
    const wrapper = divRef.current;
    const sidebar = timelineRefSidebar.current;
    const content = timelineRef.current; // #actual_timeline
    if (!wrapper || !sidebar || !content) return;
    const containerWidth = wrapper.clientWidth - sidebar.clientWidth - 19; // same as zoomToFit()
    const contentWidth = content.scrollWidth;
    if (contentWidth <= containerWidth) {
      zoomToFitRef.current();
    }
  }, []);

  // Debounce: run after any zoom change (incl. Zoom In/Out buttons or drag-repeat)
  useEffect(() => {
    if (zoomDebounceRef.current) {
      clearTimeout(zoomDebounceRef.current);
    }
    zoomDebounceRef.current = window.setTimeout(() => {
      ensureFitIfLoose();
    }, 120);
    return () => {
      if (zoomDebounceRef.current) {
        clearTimeout(zoomDebounceRef.current);
        zoomDebounceRef.current = null;
      }
    };
  }, [zoom, ensureFitIfLoose]);

  const zoomInHandlers = useAutoRepeat(handleZoomIn, {
    delay: 400,
    interval: 80,
    disabled: zoom <= MIN_ZOOM + ZOOM_EPS,
  });
  const zoomOutHandlers = useAutoRepeat(handleZoomOut, {
    delay: 400,
    interval: 80,
  });

  useEffect(() => {
    if (videoLengthInSeconds > 0 && feedId && String(feedData?.id) === feedId && feedId !== fittedFeedIdRef.current) {
      const initialVideo = feedData?.videos[Number(findSearchValue('clip') || 0)] || feedData?.videos[0];
      // The duration in the store may still belong to the previous feed while loading.
      zoomToFitRef.current(Number(initialVideo?.duration) || videoLengthInSeconds);
      autoFitOnResizeRef.current = true;
      fittedFeedIdRef.current = feedId;
    }
  }, [videoLengthInSeconds, feedId, feedData]);

  const handlePlayPause = () => {
    dispatch(toFollowPlayhead(!videoControls.playing));
    if (!videoControls.playing && !sidebarPlayback.enabled && !clipFilterActive) {
      const clip = getSelectedPlaybackClip(sortedSelectedClips, videoPlayedSeconds, markedClip?.id);
      if (clip && actions.current) {
        actions.current.seek(clip, true, videoPlayedSeconds >= clip.time_start && videoPlayedSeconds < clip.time_end
          ? videoPlayedSeconds : clip.time_start);
        return;
      }
    }
    dispatch(updateVideoControls({ ...videoControls, playing: !videoControls.playing }));
  };

  const timelineContentWrapperRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = timelineContentWrapperRef.current;
    if (!el) return;

    const onArrow = (e: KeyboardEvent) => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
      }
    };

    el.addEventListener('keydown', onArrow);
    return () => el.removeEventListener('keydown', onArrow);
  }, []);

  const [lastSelectedRow, setLastSelectedRow] = useState('');
  const emptySelectedRow = () => {
    setLastSelectedRow('');
    setSelectedRows([]);
  };

  const [selectedRows, setSelectedRows] = useState<TRow[]>([]);
  const createdClipToSelect = useRef<string | null>(null);
  useEffect(() => {
    const createdId = createdClipToSelect.current;
    if (!createdId || !videoRows.some((row) => row.clips.some((clip) => String(clip.id) === createdId))) return;
    createdClipToSelect.current = null;
    const ids = new Set([...sortedSelectedClipsRef.current.map((clip) => String(clip.id)), createdId]);
    const clips = videoRows.flatMap((row, rowIndex) => row.clips.flatMap((clip, clipIndex) => ids.has(String(clip.id))
      ? [{ ...clip, rowIndex, clipIndex, topicId: row.id, topicName: row.name }] : []));
    dispatch(updateSortedSelectedClips(clips.sort(compareTimelineClips)));
  }, [videoRows, dispatch]);
  const previousFilterConfig = useRef(clipFilterConfig);
  const previousDimmedIds = useRef(dimmedIds);
  useEffect(() => {
    if (waitingForComments) return;
    const submitted = previousFilterConfig.current !== clipFilterConfig;
    if (!submitted && previousDimmedIds.current === dimmedIds) return;
    previousFilterConfig.current = clipFilterConfig;
    previousDimmedIds.current = dimmedIds;
    if (!clipFilterActive) return;
    if (submitted) {
      const clips = videoRows.flatMap((row, rowIndex) => row.clips.flatMap((clip, clipIndex) =>
        dimmedIds.has(String(clip.id)) ? [] : [{ ...clip, rowIndex, clipIndex, topicId: row.id, topicName: row.name }],
      ));
      dispatch(updateSortedSelectedClips(clips));
      setSelectedRows([]);
      setLastSelectedRow('');
      dispatch(updateSecondaySelectedClips([]));
      return;
    }
    const clips = sortedSelectedClips.filter((clip) => !dimmedIds.has(String(clip.id)));
    if (clips.length === sortedSelectedClips.length) return;
    dispatch(updateSortedSelectedClips(clips));
    const rowIds = new Set(clips.map((clip) => String(clip.topicId)));
    setSelectedRows((rows) => rows.filter((row) => rowIds.has(String(row.id))));
    setLastSelectedRow((id) => rowIds.has(String(id)) ? id : '');
  }, [clipFilterConfig, videoRows, dimmedIds, clipFilterActive, waitingForComments, sortedSelectedClips, dispatch]);

  const handleMobileSeek = (seconds: number) => {
    notifySeek();
    dispatch(updateVideoPlayedSeconds(seconds));
    dispatch(updateTimelineSeconds(seconds));
    if (followPlayhead) {
      scrollToMarker(seconds);
    }
  };
  const handleMobileDeselect = () => {
    dispatch(updateSortedSelectedClips([]));
    dispatch(updateSecondaySelectedClips([]));
    setLastSelectedRow('');
    setSelectedRows([]);
  };

  const onSelectingRow = useCallback(
    (e: React.MouseEvent<HTMLDivElement>, doubleClick: boolean, selectedRow: TRow, rowIndex: number, selectedRowId: string) => {
      const selectedClips = sortedSelectedClipsRef.current.filter((clip) => !dimmedIds.has(String(clip.id)));
      const controls = videoControlsRef.current;
      const modifierSelection = e.ctrlKey || e.metaKey || e.shiftKey;

      if (clipDrawer) {
        dispatch(updateSortedSelectedClips([]));
        dispatch(updateSecondaySelectedClips([]));
        setLastSelectedRow('');
        setSelectedRows([]);
        setClipDrawer(null);
        return;
      }
      let arr = modifierSelection ? selectedClips.slice() : [];
      dispatch(updateReachedEnd(false));
      const selectedRowIds = selectedRows.map((row) => row.id);

      if (lastSelectedRow == selectedRowId) {
        setLastSelectedRow('');
      } else {
        setLastSelectedRow(selectedRowId);
      }

      if (selectedRows.some((row) => row.id === selectedRowId)) {
        const nextRows = selectedRows.filter((row) => row.id !== selectedRowId);
        setSelectedRows(nextRows);
      } else if (modifierSelection) {
        setSelectedRows([...selectedRows, selectedRow]);
      } else {
        setSelectedRows([selectedRow]);
      }

      const rowClipCount = selectedRow.clips.filter((clip) => !dimmedIds.has(String(clip.id))).length;
      const wasFullySelected = arr.filter((c) => c.topicId === selectedRowId).length === rowClipCount;
      const isMarkerAlreadyInsideRow = selectedRow.clips.find(
        (c) => !dimmedIds.has(String(c.id)) && controls.playedSeconds >= c.time_start && controls.playedSeconds < c.time_end,
      );
      let jumpToThisSecond = 0;
      if (wasFullySelected) {
        arr = arr.filter((c) => c.topicId !== selectedRowId);
        if (arr.find((c) => c.rowIndex === rowIndex)) {
          dispatch(
            updatePlayThisClip({
              ...selectedRow.clips[0],
              rowIndex,
              clipIndex: 0,
              topicId: selectedRowId,
              topicName: selectedRow.name,
              time_start: controls.playedSeconds,
              time_end: controls.playedSeconds + 5,
            }),
          );
        }
      } else {
        selectedRow.clips.forEach((c, i) => {
          if (dimmedIds.has(String(c.id)) || arr.some((clip) => clip.id === c.id)) return;
          arr.push({ ...c, rowIndex, clipIndex: i, topicId: selectedRowId, topicName: selectedRow.name });
        });
        if (isMarkerAlreadyInsideRow) {
          const indexOfClip = selectedRow.clips.findIndex(
            (c) => !dimmedIds.has(String(c.id)) && controls.playedSeconds >= c.time_start && controls.playedSeconds < c.time_end,
          );
          dispatch(
            imperativeMarkerSetter({
              seconds: controls.playedSeconds,
              rowIndex,
              clipIndex: indexOfClip,
            }),
          );
          jumpToThisSecond = controls.playedSeconds;
          dispatch(
            saveCurrentPlayingTimelineClip({
              ...selectedRow.clips[indexOfClip],
              rowIndex,
              clipIndex: indexOfClip,
              topicName: selectedRow.name,
              topicId: selectedRow.id,
            }),
          );
        } else {
          // jumpToThisSecond = selectedRow.clips[0].time_start + 0.001;
          // dispatch(
          //   imperativeMarkerSetter({
          //     seconds: selectedRow.clips[0].time_start,
          //     rowIndex,
          //     clipIndex: 0,
          //   }),
          // );
          // dispatch(
          //   updateMarkerPosition({
          //     rowIndex,
          //     clipIndex: 0,
          //   }),
          // );
          // dispatch(updateVideoPlayedSeconds(selectedRow.clips[0].time_start));
          // dispatch(
          //   saveCurrentPlayingTimelineClip({
          //     ...selectedRow.clips[0],
          //     rowIndex,
          //     clipIndex: 0,
          //     topicName: selectedRow.name,
          //     topicId: selectedRow.id,
          //   }),
          // );
        }
      }

      if (e.shiftKey && lastSelectedRow) {
        const prevIndex = videoRows.findIndex((r) => r.id === lastSelectedRow);
        const [start, end] = prevIndex < rowIndex ? [prevIndex, rowIndex] : [rowIndex, prevIndex];

        const newRows = videoRows.slice(start, end + 1);
        const mergedRowIds = new Set([...selectedRowIds, ...newRows.map((r) => r.id)]);
        const mergedRows = videoRows.filter((row) => mergedRowIds.has(row.id));
        setSelectedRows(mergedRows);

        for (let ri = start; ri <= end; ri++) {
          videoRows[ri].clips.forEach((c, ci) => {
            if (dimmedIds.has(String(c.id))) return;
            if (!arr.find((x) => x.id === c.id && x.rowIndex === ri && x.clipIndex === ci)) {
              arr.push({
                ...c,
                rowIndex: ri,
                clipIndex: ci,
                topicId: videoRows[ri].id,
                topicName: videoRows[ri].name,
              });
            }
          });
        }
      }

      arr.sort((a, b) => {
        if (a.time_start !== b.time_start) {
          return a.time_start - b.time_start;
        } else if (a.rowIndex !== b.rowIndex) {
          return a.rowIndex - b.rowIndex;
        } else {
          return 0;
        }
      });
      dispatch(updateSortedSelectedClips(arr));
      if (doubleClick) {
        const firstClipIndex = clipFilterActive
          ? selectedRow.clips.findIndex((clip) => !dimmedIds.has(String(clip.id)) && clip.time_end > clip.time_start)
          : 0;
        const firstClip = selectedRow.clips?.[firstClipIndex];
        dispatch(
          updateVideoControls({
            ...controls,
            playedSeconds: jumpToThisSecond ? jumpToThisSecond : controls.playedSeconds,
            playing: !clipFilterActive || !!firstClip,
          }),
        );
        if (!firstClip) {
          dispatch(toFollowPlayhead(true));
          dispatch(triggerRefresh());
          return;
        }
        if (clipFilterActive) {
          seekFilteredClip({
            ...firstClip,
            rowIndex,
            clipIndex: firstClipIndex,
            topicName: selectedRow.name,
            topicId: selectedRow.id,
          });
          return;
        }
        enterClip(firstClip.id);
        dispatch(updateVideoPlayedSeconds(firstClip.time_start));
        dispatch(
          imperativeMarkerSetter({
            rowIndex,
            clipIndex: 0,
            seconds: firstClip.time_start,
          }),
        );
        dispatch(
          saveCurrentPlayingTimelineClip({
            ...firstClip,
            rowIndex,
            clipIndex: 0,
            topicName: selectedRow.name,
            topicId: selectedRow.id,
          }),
        );
      }
      dispatch(toFollowPlayhead(true));
      dispatch(triggerRefresh());
    },
    [videoRows, selectedRows, lastSelectedRow, clipFilterActive, dimmedIds, seekFilteredClip, enterClip],
  );

  const switchNotes = () => {
    dispatch(updateShowNotes(!showNotes));
  };

  const [showJsonModal, setShowJsonModal] = useState(false);
  const [showCreateEmptyTimelineModal, setShowCreateEmptyTimelineModal] = useState(false);
  const [creatingEmptyTimeline, setCreatingEmptyTimeline] = useState(false);
  const switchUploadJson = () => {
    setShowJsonModal(!showJsonModal);
  };

  const createEmptyTimeline = async (timelineName: string) => {
    if (!currentFeed || creatingEmptyTimeline) return;

    setCreatingEmptyTimeline(true);
    try {
      const isAllContent = findSearchValue('allContent') === 'true';
      const response = await postCreateEmptyTimeline(currentFeed.id, timelineName, {
        allContent: isAllContent,
      });
      const nextFeedId = Number(response?.data?.videofeedId || 0);

      if (folderId) {
        if (isAllContent) {
          await dispatch(
            getAllContentVideofeedsThunk({
              folderId,
              sort: SortType.ASC,
              sortOption: SortOptions.NAME,
            }),
          );
        } else if (shared) {
          await dispatch(
            getAllSharedVideoFeedsByFolderId({
              folderId,
              sort: SortType.ASC,
              sortOption: SortOptions.NAME,
            }),
          );
        } else {
          await dispatch(getAllVideoFeedsByFolderId({ folderId }));
        }
      }

      if (nextFeedId) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('feedId', String(nextFeedId));
        if (Number.isFinite(displayPlayedSeconds) && displayPlayedSeconds > 0) {
          currentUrl.searchParams.set('timeToJump', String(displayPlayedSeconds));
        }
        routerHistory.replace(`${currentUrl.pathname}${currentUrl.search}`);
        await getCurrentVideofeed(nextFeedId);
      } else {
        await fetchData(true);
      }
      setShowCreateEmptyTimelineModal(false);
      enqueueSnackbar('Empty timeline created', { variant: 'success' });
    } catch (error: any) {
      notification.showMessage(error?.response?.data?.message || 'Failed to create empty timeline');
    } finally {
      setCreatingEmptyTimeline(false);
    }
  };

  const onRulerChange = (timeInSeconds: number | number[], e: any) => {
    dispatch(toFollowPlayhead(false));
    if (e?.type === 'input') return;
    if (typeof timeInSeconds === 'number') {
      notifySeek();
      dispatch(updateVideoPlayedSeconds(timeInSeconds));
      dispatch(updateTimelineSeconds(timeInSeconds));
    }
  };

  const zoomedMargin = useMemo(() => {
    const margin = TIMELINE_MARK_MARGIN + 1;
    return margin / zoom;
  }, [TIMELINE_MARK_MARGIN, zoom]);

  const disablePlayheadFollowing = useCallback(() => {
    if (followPlayhead) {
      dispatch(toFollowPlayhead(false));
    }
  }, [dispatch, followPlayhead]);

  const disablePlayheadFollowerCallback = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      disablePlayheadFollowing();
    }
  };

  const [showSendClipModal, setShowSendClipModal] = useState(false);
  const switchSendClipModal = (open?: any) => {
    if (!canSendClips) return;
    const willOpen = typeof open === 'boolean' ? open : !showSendClipModal;
    if (willOpen && videoControls.playing) {
      dispatch(updateVideoControls({ ...videoControls, playing: false }));
      notifyHidePauseOverlay();
    }
    setShowSendClipModal(willOpen);
  };

  const { onMouseDown: onDragScrollMouseDown } = useDraggableScroll(timelineContentWrapperRef, { direction: 'vertical' });
  const handleTimelineMouseDown = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      // Option is reserved for row-reorder gesture; disable drag-to-scroll while held.
      if (e.altKey) return;
      onDragScrollMouseDown(e);
    },
    [onDragScrollMouseDown],
  );
  const handleManualTimelineMouseMove = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.buttons === 1) {
        disablePlayheadFollowing();
      }
    },
    [disablePlayheadFollowing],
  );
  const [skipConfirmationModals, setSkipConfirmationModals] = useState(false);
  const [showCreateOrSendModal, setShowCreateOrSendModal] = useState(false);

  const switchCreateOrSendModal = () => {
    if (!canSendClips) return;
    const willOpen = !showCreateOrSendModal;
    if (willOpen && videoControls.playing) {
      dispatch(updateVideoControls({ ...videoControls, playing: false }));
      notifyHidePauseOverlay();
    }
    setShowCreateOrSendModal(willOpen);
    setClipDrawer(null);
  };

  useEffect(() => {
    if (currentPlayingTimelineClip) {
      const noteMessages = currentPlayingTimelineClip.notes.map((c) => c.note);
      dispatch(updateNotes([noteMessages.map(() => currentPlayingTimelineClip.topicName!), noteMessages]));
      if (currentPlayingTimelineClip?.qualifiers) {
        // @ts-ignore
        dispatch(updateQualifiers([...currentPlayingTimelineClip.qualifiers]));
      }
    } else if (!currentPlayingTimelineClip) {
      dispatch(updateNotes([]));
      dispatch(updateQualifiers([]));
    }
  }, [currentPlayingTimelineClip]);

  const [rowNameWidth, setRowNameWidth] = useState(getInitialTimelineSidebarWidth);
  const [markerHeight, setMarkerHeight] = useState<number>(0);
  const previousScrollTop = useRef(0);

  useLayoutEffect(() => {
    if (!collapsed && timelineContentWrapperRef.current) {
      timelineContentWrapperRef.current.scrollTop = previousScrollTop.current;
    }
  }, [collapsed]);

  useEffect(() => {
    if (timelineRefSidebar?.current?.offsetHeight) {
      if (videoRows.length === 0) {
        setMarkerHeight(timelineRefSidebar?.current?.offsetHeight + 10);
      } else {
        setMarkerHeight(timelineRefSidebar?.current?.offsetHeight + 7);
      }
    }
  }, [timelineRefSidebar, videoPlayerHeight, videoRows, collapsed, collapsedRowIds, clipDrawer?.topicId]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // setMarkerHeight(entry.intersectionRect.height);
        }
      });
    });
    if (timelineContentWrapperRef.current) {
      observer.observe(timelineContentWrapperRef.current);
    }
    return () => {
      if (timelineContentWrapperRef.current) {
        observer.unobserve(timelineContentWrapperRef.current);
      }
    };
  }, [videoPlayerHeight]);

  const [nameWidth, setNameWidth] = useState(getInitialTimelineNameWidth);

  useEffect(() => {
    if (isNarrowScreen) {
      setRowNameWidth((currentWidth) => Math.min(currentWidth, MOBILE_ROW_NAME_WIDTH));
      setNameWidth((currentWidth) => Math.min(currentWidth, MOBILE_NAME_WIDTH));
      return;
    }

    setRowNameWidth((currentWidth) => (currentWidth < DESKTOP_SIDEBAR_MIN_WIDTH ? DEFAULT_ROW_NAME_WIDTH : currentWidth));
    setNameWidth((currentWidth) => (currentWidth < DEFAULT_NAME_WIDTH ? DEFAULT_NAME_WIDTH : currentWidth));
  }, [isNarrowScreen]);

  const switchFullScreen = () => {
    if (!fullScreen.active) {
      fullScreen.enter();
    } else {
      fullScreen.exit();
    }
  };

  const speedOptionMenuRef = useRef<HTMLDivElement | null>(null);
  useOnClickOutside(speedOptionMenuRef, (e) => {
    setTimeout(() => {
      dispatch(setShowSpeedOption(false));
    }, 300);
  });
  const switchSpeedOptionMenu = () => {
    dispatch(setShowSpeedOption(!showSpeedOption));
  };

  const handleVolumeChange = (event: Event, newValue: number | number[]) => {
    const nextVolume = (newValue as number) / 100;
    rememberManualVolumeOverrideForFeed(feedId, nextVolume);
    dispatch(updateVideoControls({ ...videoControls, volume: nextVolume }));
  };
  const muteSwitch = () => {
    const nextVolume = videoControls.volume > 0 ? 0 : 1;
    rememberManualVolumeOverrideForFeed(feedId, nextVolume);
    dispatch(updateVideoControls({ ...videoControls, volume: nextVolume }));
  };
  const [showVolume, setShowVolume] = useState(false);
  const showVolumeSlider = () => {
    setShowVolume(true);
  };
  const closeVolumeSlider = () => {
    setShowVolume(false);
  };

  const divRef = useRef<HTMLDivElement>(null);
  // useEffect(() => {
  //   const handleKeyDown = (event: KeyboardEvent) => {
  //     if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
  //       event.preventDefault();
  //     }
  //   };
  //   const divElement = divRef.current;
  //   if (divElement) {
  //     divElement.addEventListener('keydown', handleKeyDown);
  //   }
  //   return () => {
  //     if (divElement) {
  //       divElement.removeEventListener('keydown', handleKeyDown);
  //     }
  //   };
  // }, []);

  const markerOffset = useMemo(() => {
    return displayPlayedSeconds * zoomedMargin + 1;
  }, [displayPlayedSeconds, zoomedMargin]);

  const scrollToMarker = (seconds?: number) => {
    const timelineParentScroller = document.getElementById('timeline_parent_scroller');
    const mo = seconds === undefined ? markerOffset : seconds * zoomedMargin + 1;
    if (timelineParentScroller) {
      const scrollOffset = isNarrowScreen
        ? Math.max(0, timelineParentScroller.clientWidth - (timelineRefSidebar.current?.offsetWidth || 0)) / 2
        : timelineParentScroller.offsetWidth / 2 - 200;
      const currentScroll = timelineParentScroller.scrollLeft;
      let scrollTo = mo - scrollOffset;
      if (scrollTo < 0) {
        scrollTo = 0;
      }
      const maxScroll = timelineParentScroller.scrollWidth - timelineParentScroller.clientWidth;
      scrollTo = Math.max(0, Math.min(scrollTo, maxScroll));
      if (scrollTo !== currentScroll) {
        timelineParentScroller.scrollTo({
          left: scrollTo,
        });
      }
    }
  };

  const toggleMobileFollowPlayhead = () => {
    const nextFollowPlayhead = !followPlayhead;
    dispatch(toFollowPlayhead(nextFollowPlayhead));
    if (nextFollowPlayhead) {
      scrollToMarker();
    }
  };

  useEffect(() => {
    if (followPlayhead) {
      scrollToMarker();
    }
  }, [followPlayhead, displayPlayedSeconds]);

  const [initialClipDrawer, setInitialClipDrawer] = useState<{ time_start: number; time_end: number; color?: string }>({
    time_start: 0,
    time_end: 0,
    color: '#7C7C72',
  });
  const onCancelDrawerClick = () => {
    setClipDrawer({
      ...clipDrawer!,
      time_start: initialClipDrawer.time_start,
      time_end: initialClipDrawer.time_end,
      color: initialClipDrawer.color,
    });
    setHasOverlap(false);
  };

  useEffect(() => {
    const previous = previousFilteredPlayback.current;
    previousFilteredPlayback.current = { id: markedClip?.id, seconds: displayPlayedSeconds, playing: videoControls.playing };
    if (!clipFilterActive || sidebarPlayback.enabled || !videoControls.playing || isDraggingCursor || videoControls.seeking || clipDrawer) return;
    const resumed = !previous.playing;
    const insideClip = markedClip && displayPlayedSeconds >= markedClip.time_start && displayPlayedSeconds < markedClip.time_end;
    if (!filteredNavigationClips.length) {
      if (!insideClip) stopFilteredPlayback(markedClip && displayPlayedSeconds >= markedClip.time_end ? markedClip.time_end : displayPlayedSeconds);
      return;
    }
    if (resumed && !insideClip && (!markedClip || displayPlayedSeconds < markedClip.time_start || reachedEnd)) {
      const next = reachedEnd ? filteredNavigationClips[0] : filteredNavigationClips.find((clip) => clip.time_end > displayPlayedSeconds);
      if (next) seekFilteredClip(next);
      else stopFilteredPlayback();
      return;
    }
    if (!markedClip) return;
    const crossedEnd = previous.id === markedClip.id && previous.seconds < markedClip.time_end && displayPlayedSeconds >= markedClip.time_end;
    if (!(crossedEnd || resumed) || displayPlayedSeconds < markedClip.time_end) return;
    advanceFilteredPlayback();
  }, [clipFilterActive, sidebarPlayback.enabled, videoControls.playing, videoControls.seeking, isDraggingCursor, clipDrawer,
    filteredNavigationClips, markedClip, markerPosition, displayPlayedSeconds, reachedEnd, seekFilteredClip, stopFilteredPlayback, advanceFilteredPlayback]);

  const handleEditClip = (clip?: CLIP) => {
    if (!clip) return;

    const { id, time_end, time_start, color, topicId, rowIndex, clipIndex } = clip;
    setInitialClipDrawer({
      time_start,
      time_end,
      color: parseColorToHex(color),
    });

    setClipDrawer({
      time_start,
      time_end,
      id,
      color: parseColorToHex(color),
      topicId: topicId!,
      isEdit: true,
    });

    dispatch(updateTimelineSeconds(time_start));
    dispatch(updateVideoPlayedSeconds(time_start));
    dispatch(updateVideoControls({ ...videoControlsRef.current, playing: false, playedSeconds: time_start }));
    dispatch(imperativeMarkerSetter({ rowIndex: rowIndex!, clipIndex: clipIndex!, seconds: time_start }));
  };

  const calculateRowClips = (clips: TClip[]) => {
    if (clipDrawer) {
      const editedClip = clips.some((clip) => clip.id === clipDrawer.id);

      if (editedClip) {
        return clips.filter((clip) => clip.id !== clipDrawer.id);
      }
    }

    return clips;
  };

  const dismissClipDrawer = useCallback(() => {
    setShowColorPicker(false);
    setDragging(null);
    setClipDrawer(null);
    setHasOverlap(false);
  }, []);

  const onClipDrawerClose = () => {
    dismissClipDrawer();
  };

  const timelineRef = useRef<HTMLDivElement>(null);
  const [shiftTrim, setShiftTrim] = useState(false);
  useEffect(() => {
    const update = (event: KeyboardEvent) => setShiftTrim(event.shiftKey && !event.ctrlKey && !event.metaKey && !event.altKey);
    const clear = () => setShiftTrim(false);
    window.addEventListener('keydown', update);
    window.addEventListener('keyup', update);
    window.addEventListener('blur', clear);
    return () => {
      window.removeEventListener('keydown', update);
      window.removeEventListener('keyup', update);
      window.removeEventListener('blur', clear);
    };
  }, []);
  const notification = useSnackbar();
  const pauseTimelinePlayback = useCallback(() => {
    if (!videoControls.playing) return;
    dispatch(updateVideoControls({ ...videoControls, playing: false }));
  }, [dispatch, videoControls]);

  const createClipDrawer = (e: React.MouseEvent<HTMLDivElement>, rowId: string) => {
    if (currentFeed?.created_by.id === currentUser?.id || userAccess === ACCESS_TYPE_ENUM.EDIT_AND_RE_SHARE || canEdit) {
      pauseTimelinePlayback();
      const timelineRect = timelineRef.current!.getBoundingClientRect();
      const offsetX = e.clientX - timelineRect.left + timelineRef.current!.scrollLeft;
      const totalTimelineWidth = (videoLengthInSeconds * (TIMELINE_MARK_MARGIN + 1)) / zoom;
      const clickedSecond = (offsetX / totalTimelineWidth) * videoLengthInSeconds;
      const targetRow = videoRows.find((row) => +row.id === +rowId);
      if (targetRow) {
        const MIN_CLIP_LENGTH = 1;
        const { clipDefaultInSeconds, clipDefaultOutSeconds } = getComposerWebPreferences();
        const defaultDuration = clipDefaultInSeconds + clipDefaultOutSeconds;
        let proposedStart: number;
        let proposedEnd: number;
        if (clickedSecond < clipDefaultInSeconds) {
          proposedStart = 0;
          proposedEnd = Math.min(videoLengthInSeconds, defaultDuration);
        } else {
          proposedStart = Math.max(0, clickedSecond - clipDefaultInSeconds);
          proposedEnd = Math.min(videoLengthInSeconds, clickedSecond + clipDefaultOutSeconds);
        }
        if (proposedEnd - proposedStart < MIN_CLIP_LENGTH) {
          notification.showMessage('No space available.');
          return;
        }
        const sortedClips = targetRow.clips.slice().sort((a, b) => a.time_start - b.time_start);
        for (const clip of sortedClips) {
          if (proposedEnd > clip.time_start && proposedStart < clip.time_end) {
            if (clickedSecond < clip.time_start) {
              proposedEnd = Math.min(proposedEnd, clip.time_start);
            } else if (clickedSecond > clip.time_end) {
              proposedStart = Math.max(proposedStart, clip.time_end);
            } else {
              notification.showMessage('No space available.');
              return;
            }
          }
        }
        if (proposedEnd - proposedStart >= MIN_CLIP_LENGTH) {
          const mostCommonColor = targetRow.details?.color || detectMostCommonRowColor(targetRow) || '#7C7C72';

          setInitialClipDrawer({ time_start: proposedStart, time_end: proposedEnd, color: mostCommonColor });
          setClipDrawer({
            time_start: proposedStart,
            time_end: proposedEnd,
            topicId: rowId,
            id: `${rowId}_${proposedStart}`,
            color: mostCommonColor,
          });
        } else {
          notification.showMessage('No space available.');
        }
      }
    }
  };

  const [dragging, setDragging] = useState<'left' | 'right' | null>(null);
  const initialXRef = useRef<number>(0);
  const initialStartRef = useRef<number>(0);
  const initialEndRef = useRef<number>(0);
  const onClipEdgeResize = (event: React.MouseEvent, clip: CLIP, side: 'left' | 'right') => {
    if (!canEdit || clipDrawer) return;
    handleEditClip(clip);
    initialXRef.current = event.clientX;
    initialStartRef.current = clip.time_start;
    initialEndRef.current = clip.time_end;
    setDragging(side);
  };
  const handleMouseDown = (e: React.MouseEvent, side: 'left' | 'right') => {
    e.stopPropagation();
    e.preventDefault();
    if (clipDrawer) {
      setDragging(side);
      initialXRef.current = e.clientX;
      initialStartRef.current = clipDrawer.time_start;
      initialEndRef.current = clipDrawer.time_end;
    }
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (!dragging || !clipDrawer) return;
    const deltaPixels = e.clientX - initialXRef.current;
    const deltaSeconds = deltaPixels / zoomedMargin;
    const currentRow = videoRows.find((row) => row.id === clipDrawer.topicId);
    const rowClips = currentRow ? currentRow.clips : [];
    if (dragging === 'left') {
      let newStart = initialStartRef.current + deltaSeconds;
      newStart = Math.min(newStart, clipDrawer.time_end - 1);
      newStart = Math.max(newStart, 0);
      const { start } = findOverlapBoundary(newStart, clipDrawer.time_end, rowClips, 'left', clipDrawer.id);
      setClipDrawer({ ...clipDrawer, time_start: start });

      dispatch(updateVideoPlayedSeconds(start));
      dispatch(updateTimelineSeconds(start));
    } else if (dragging === 'right') {
      let newEnd = initialEndRef.current + deltaSeconds;
      newEnd = Math.max(newEnd, clipDrawer.time_start + 1);
      newEnd = Math.min(newEnd, videoLengthInSeconds);
      const { end } = findOverlapBoundary(clipDrawer.time_start, newEnd, rowClips, 'right', clipDrawer.id);
      setClipDrawer({ ...clipDrawer, time_end: end });

      dispatch(updateVideoPlayedSeconds(end));
      dispatch(updateTimelineSeconds(end));
    }
  };

  const switchDownloadDataModal = () => {
    setShowDownloadModal(!showDownloadModal);
  };

  const handleDownloadClick = () => {
    setShowDownloadModal(true);
  };

  const handleMouseUp = () => setDragging(null);

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [dragging, clipDrawer]);

  const parseTimeInput = (input: string): number => {
    if (input.includes(':')) {
      const parts = input.split(':').map(Number);
      if (parts.length === 2) {
        return parts[0] * 60 + parts[1];
      } else if (parts.length === 3) {
        return parts[0] * 3600 + parts[1] * 60 + parts[2];
      }
    }
    return Number(input);
  };

  function handleStartBlur(e: React.FocusEvent<HTMLInputElement>) {
    setHasOverlap(false);
    let newStart = parseTimeInput(e.target.value);
    const clips = videoRows.find((v) => v.id === clipDrawer?.topicId)?.clips.filter((clip) => clip.id !== clipDrawer?.id) || [];

    // Ensure newStart doesn't fall inside an existing clip
    clips.forEach((clip) => {
      if (newStart >= clip.time_start && newStart < clip.time_end) {
        newStart = clip.time_end;
      }
    });

    let gapStart = 0;
    let gapEnd = videoLengthInSeconds;
    clips.forEach((clip) => {
      if (clip.time_end <= newStart && clip.time_end > gapStart) {
        gapStart = clip.time_end;
      }
      if (clip.time_start > newStart && clip.time_start < gapEnd) {
        gapEnd = clip.time_start;
      }
    });
    if (newStart < gapStart) newStart = gapStart;

    // If time_end was already set, check if it's valid (i.e. not overlapping)
    let newEnd: number;
    if (clipDrawer?.time_end) {
      const isValid =
        clipDrawer.time_end > newStart &&
        clipDrawer.time_end <= gapEnd &&
        !clips.some((clip) => clipDrawer.time_end > clip.time_start && clipDrawer.time_end < clip.time_end);
      newEnd = isValid ? clipDrawer.time_end : newStart + 10;
    } else {
      newEnd = newStart + 10;
    }

    if (newEnd > gapEnd) newEnd = gapEnd;
    if (newEnd - newStart < 1) {
      newEnd = newStart + 1;
      if (newEnd > gapEnd) {
        newStart = gapEnd - 1;
        newEnd = gapEnd;
      }
    }

    setClipDrawer({ ...clipDrawer!, time_start: newStart, time_end: newEnd });
  }

  function handleEndBlur(e: React.FocusEvent<HTMLInputElement>) {
    setHasOverlap(false);
    const newEnd = parseTimeInput(e.target.value);
    const newEndConstrained = Math.min(newEnd, videoLengthInSeconds);
    const constrainedEnd = Math.max(newEndConstrained, clipDrawer!.time_start + 1);
    const clips = videoRows.find((v) => v.id == clipDrawer?.topicId)?.clips.filter((clip) => clip.id !== clipDrawer?.id);
    if (clips) {
      const { end } = findOverlapBoundary(clipDrawer!.time_start, constrainedEnd, clips, 'right', clipDrawer!.id);
      setClipDrawer({ ...clipDrawer!, time_end: end });
    } else {
      setClipDrawer({ ...clipDrawer!, time_end: constrainedEnd });
    }
  }

  const [showColorPicker, setShowColorPicker] = useState(false);
  const switchColorPicker = () => {
    setShowColorPicker(!showColorPicker);
  };

  useEffect(() => {
    if (showColorPicker) {
      const element = document.querySelector('.w-color-interactive.w-color-saturation');
      if (element instanceof HTMLElement) {
        element.click();
      }
    }
  }, [showColorPicker]);

  useLayoutEffect(() => {
    if (!clipDrawer) {
      setShowColorPicker(false);
      return;
    }
    const modalEl = document.getElementById('clip-drawer-modal');
    const timelineArea = timelineContentWrapperRef.current;
    const clipHandles = timelineArea?.querySelector('[data-clip-drawer-handle]');
    if (!modalEl || !timelineArea || !clipHandles) return;

    const updatePosition = () => {
      // Centre the default position above the clip handles; keep the draggable offset separate.
      const area = timelineArea.getBoundingClientRect();
      const handles = clipHandles.getBoundingClientRect();
      const preferredTop = handles.top - modalEl.offsetHeight - 12;
      const top = Math.max(8, Math.min(preferredTop, window.innerHeight - modalEl.offsetHeight - 8));
      const minLeft = Math.max(8, area.left + 8);
      const maxLeft = Math.min(window.innerWidth, area.right) - modalEl.offsetWidth - 8;
      const left = Math.max(minLeft, Math.min(handles.left + handles.width / 2 - modalEl.offsetWidth / 2, maxLeft));
      modalEl.style.top = `${top - area.top}px`;
      modalEl.style.left = `${left - area.left}px`;
    };
    updatePosition();

    let resizeTimeout: ReturnType<typeof setTimeout>;
    const schedulePositionUpdate = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updatePosition, 150);
    };
    const observer = new ResizeObserver(schedulePositionUpdate);
    observer.observe(timelineArea);
    observer.observe(modalEl);
    timelineArea.addEventListener('scroll', schedulePositionUpdate, true);
    window.addEventListener('resize', schedulePositionUpdate);
    return () => {
      clearTimeout(resizeTimeout);
      observer.disconnect();
      timelineArea.removeEventListener('scroll', schedulePositionUpdate, true);
      window.removeEventListener('resize', schedulePositionUpdate);
    };
  }, [clipDrawer?.id, clipDrawer?.topicId, videoPlayerHeight, zoom]);

  const [loading, setLoading] = useState(false);

  const createdNewRowCallBack = async ({
    id,
    name,
    topicIndex,
    clips,
    topicDetails,
    videofeedId: nextFeedId,
  }: TOPIC & { videofeedId?: number }) => {
    const createdInNewFeed = nextFeedId && String(nextFeedId) !== String(feedId || '');
    if (createdInNewFeed) {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('feedId', String(nextFeedId));
      if (Number.isFinite(displayPlayedSeconds) && displayPlayedSeconds > 0) {
        currentUrl.searchParams.set('timeToJump', String(displayPlayedSeconds));
      }
      routerHistory.replace(`${currentUrl.pathname}${currentUrl.search}`);

      if (folderId) {
        if (shared) {
          await dispatch(
            getAllSharedVideoFeedsByFolderId({
              folderId,
              sort: SortType.ASC,
              sortOption: SortOptions.NAME,
            }),
          );
        } else {
          await dispatch(getAllVideoFeedsByFolderId({ folderId }));
        }
      }
    }
    pauseTimelinePlayback();
    setSelectedRows([{ id, name, clips: [], details: topicDetails as TRow['details'] }]);
    setSession((previous) => [...previous, { topic: { id, topicIndex: topicIndex || 0, name, clips, topicDetails, status: 'created' } }]);
    setLastSelectedRow(id);
    dispatch(updateSortedSelectedClips([]));
    dispatch(updateSecondaySelectedClips([]));
    if (createdInNewFeed) {
      await getCurrentVideofeed(nextFeedId);
    } else {
      await fetchData(true);
    }
  };

  const sessionUpdate = async () => {
    await fetchData(true);
    clipDrawer && setClipDrawer(null);
    setShowColorPicker(false);
  };

  const onClipCreate = async (clipData?: any) => {
    if ((clipDrawer || clipData) && feedId) {
      try {
        let res: any;
        setLoading(true);
        if (clipData) {
          res = await createClipForTopic(
            {
              topic_id: +clipData.topicId,
              time_start: clipData.time_start,
              time_end: clipData.time_end,
              color: clipData.color ? hexToNormalizedRGB(clipData.color) : '',
              comments: clipData?.comments,
              notes: clipData.notes,
              qualifiers: clipData.qualifiers,
            },
            +feedId,
          );
        } else if (clipDrawer?.isEdit) {
          res = await editClip(
            { color: hexToNormalizedRGB(clipDrawer.color!), time_end: clipDrawer.time_end, time_start: clipDrawer.time_start },
            +clipDrawer.id!,
          );
        } else if (clipDrawer) {
          res = await createClipForTopic(
            {
              topic_id: +clipDrawer.topicId,
              time_start: clipDrawer.time_start,
              time_end: clipDrawer.time_end,
              color: clipDrawer.color ? hexToNormalizedRGB(clipDrawer.color) : '',
            },
            +feedId,
          );
        }
        if (res) {
          if (res.data?.id && !clipDrawer?.isEdit) createdClipToSelect.current = String(res.data.id);
          await sessionUpdate();
        }
        if (res?.data?.id) {
          if (clipDrawer && clipDrawer?.isEdit) {
            const selectedTopic = videoRows.find((row) => row.id === clipDrawer.topicId);
            const selectedClip = selectedTopic!.clips.find((clip) => clip.id === clipDrawer.id);

            const { id, color, time_start, time_end, topicId } = selectedClip!;
            setSession((previous) => [
              ...previous,
              {
                clip: {
                  id: id!,
                  color: hexToNormalizedRGB(color!) || '1.0,1.0,1.0',
                  time_start: time_start.toString(),
                  time_end: time_end.toString(),
                  status: 'edited',
                  topicId: topicId!,
                },
              },
            ]);
          } else if (!clipData) {
            const {
              color,
              id,
              time_start,
              time_end,
              topic: { id: topicId },
            } = res.data;
            setSession((previous) => [...previous, { clip: { id, color, time_start, time_end, status: 'created', topicId } }]);
          }
        }
        return res.data;
      } catch (e: any) {
        console.error(e);
        if (e?.response?.data?.message) {
          notification.showMessage(e?.response?.data?.message);
        }
      } finally {
        dispatch(updateNotificationTrigger(Date.now()));
        setLoading(false);
      }
    }
  };

  const [createRowModal, setCreateRowModal] = useState(false);
  const switchCreateRowModal = () => {
    if (!createRowModal) {
      pauseTimelinePlayback();
    }
    setCreateRowModal(!createRowModal);
  };

  const handleAddClip = (id?: string, argVideofeed?: VIDEOFEED) => {
    pauseTimelinePlayback();
    if (!argVideofeed && videoRows.length === 0) return;
    const videoLengthInSeconds = videoLength / 1000;
    const minDuration = 1;
    const playhead = videoControls.playedSeconds || 0;

    // Finds any gap in the row (ignoring playedSeconds)
    const findGapInRow = (row: TRow) => {
      const sortedClips = [...row.clips].sort((a, b) => a.time_start - b.time_start);
      if (sortedClips.length === 0) return { start: 0, end: videoLengthInSeconds };
      if (sortedClips[0].time_start >= minDuration) return { start: 0, end: sortedClips[0].time_start };
      for (let i = 0; i < sortedClips.length - 1; i++) {
        const gapStart = sortedClips[i].time_end;
        const gapEnd = sortedClips[i + 1].time_start;
        if (gapEnd - gapStart >= minDuration) return { start: gapStart, end: gapEnd };
      }
      const lastGap = videoLengthInSeconds - sortedClips[sortedClips.length - 1].time_end;
      if (lastGap >= minDuration) return { start: sortedClips[sortedClips.length - 1].time_end, end: videoLengthInSeconds };
      return null;
    };

    // Builds an array of gaps and picks the one nearest to the given time.
    const findGapInRowForTime = (row: TRow, time: number) => {
      const sortedClips = [...row.clips].sort((a, b) => a.time_start - b.time_start);
      let gaps: { start: number; end: number }[] = [];
      if (sortedClips.length === 0) {
        gaps.push({ start: 0, end: videoLengthInSeconds });
      } else {
        if (sortedClips[0].time_start >= minDuration) {
          gaps.push({ start: 0, end: sortedClips[0].time_start });
        }
        for (let i = 0; i < sortedClips.length - 1; i++) {
          const gapStart = sortedClips[i].time_end;
          const gapEnd = sortedClips[i + 1].time_start;
          if (gapEnd - gapStart >= minDuration) {
            gaps.push({ start: gapStart, end: gapEnd });
          }
        }
        const lastClipEnd = sortedClips[sortedClips.length - 1].time_end;
        if (videoLengthInSeconds - lastClipEnd >= minDuration) {
          gaps.push({ start: lastClipEnd, end: videoLengthInSeconds });
        }
      }
      if (gaps.length === 0) return null;
      for (const gap of gaps) {
        if (time >= gap.start && time <= gap.end - minDuration) {
          return gap;
        }
      }
      let closestGap = gaps[0];
      let minDist = Infinity;
      for (const gap of gaps) {
        let dist;
        if (time < gap.start) {
          dist = gap.start - time;
        } else if (time > gap.end - minDuration) {
          dist = time - (gap.end - minDuration);
        } else {
          dist = 0;
        }
        if (dist < minDist) {
          minDist = dist;
          closestGap = gap;
        }
      }
      return closestGap;
    };

    let rows: any = argVideofeed?.topics || videoRows;
    let preferedTopicId = isValidArg(id) ? id : lastSelectedRow || selectedRows.at(-1)?.id || '';
    let preferedRow = rows.find((t: any) => t.id == preferedTopicId) as TRow;
    let candidateGap = null;
    let targetRow = preferedRow || null;

    // Helper: Apply centering logic to create a clip around the playhead.
    const tryApplyClip = (gap: { start: number; end: number }, row: TRow) => {
      const mostCommonColor = row.details?.color || detectMostCommonRowColor(row) || '#7C7C72';

      const { clipDefaultInSeconds, clipDefaultOutSeconds } = getComposerWebPreferences();
      const defaultDuration = clipDefaultInSeconds + clipDefaultOutSeconds;
      let targetStart = playhead - clipDefaultInSeconds;
      let targetEnd = playhead + clipDefaultOutSeconds;
      // Adjust if the ideal clip extends beyond the gap.
      if (targetStart < gap.start) {
        targetStart = gap.start;
        targetEnd = targetStart + defaultDuration;
      }
      if (targetEnd > gap.end) {
        targetEnd = gap.end;
        targetStart = targetEnd - defaultDuration;
      }
      // Clamp to the gap.
      targetStart = Math.max(gap.start, targetStart);
      targetEnd = Math.min(gap.end, targetEnd);
      if (targetEnd - targetStart < minDuration) {
        return false;
      }
      setInitialClipDrawer({ time_start: targetStart, time_end: targetEnd });
      setClipDrawer({ time_start: targetStart, time_end: targetEnd, topicId: row.id, color: mostCommonColor });
      return true;
    };

    // First, if a preferred row exists, try to use it.
    if (preferedRow) {
      candidateGap = findGapInRowForTime(preferedRow, playhead) || findGapInRow(preferedRow);
      if (candidateGap && tryApplyClip(candidateGap, preferedRow)) {
        return;
      }
    }

    // If no preferred row or clip wasn't applied, iterate over all rows.
    for (let row of rows) {
      candidateGap = findGapInRowForTime(row, playhead) || findGapInRow(row);
      if (candidateGap && tryApplyClip(candidateGap, row)) {
        return;
      }
    }

    notification.showMessage('No available space for a new clip.');
  };

  const onLocateDrawer = () => {
    if (clipDrawer?.id) {
      document.getElementById(clipDrawer?.id)?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    }
  };

  const clipDrawerRef = useRef<HTMLDivElement | null>(null);
  const clipColorButtonRef = useRef<HTMLDivElement | null>(null);

  useOnClickOutside(clipDrawerRef, (event) => {
    if (!clipDrawer?.isEdit) return;

    const target = event.target;
    if (target instanceof Element && target.closest('[data-clip-drawer-handle], [data-preserve-clip-edit]')) {
      return;
    }

    dismissClipDrawer();
  });

  useEffect(() => {
    if (!clipDrawer) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        dismissClipDrawer();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [clipDrawer, dismissClipDrawer]);

  const [hasOverlap, setHasOverlap] = useState(false);

  const checkOverlap = useCallback(
    (newStart: number, newEnd: number) => {
      const clips = videoRows.find((row) => row.id == clipDrawer?.topicId)?.clips || [];
      const exceeded = newStart < 0 || newStart > videoLengthInSeconds || newEnd > videoLengthInSeconds;
      if (exceeded) {
        notification.showMessage('Clip duration is out of video length.');
        return true;
      }

      const isOverlap = clips
        .filter((elem) => elem.id !== clipDrawer?.id)
        .some((clip) => newStart < clip.time_end && newEnd > clip.time_start);

      if (isOverlap) {
        notification.showMessage('Clip has overlap.');
        return true;
      }
      return false;
    },
    [clipDrawer?.id, clipDrawer?.topicId, notification, videoLengthInSeconds, videoRows],
  );

  const setClipBoundaryToPlayhead = useCallback(
    (boundary: 'in' | 'out') => {
      if (!clipDrawer) return;

      const playhead = Math.max(0, Math.min(displayPlayedSeconds, videoLengthInSeconds));
      const newStart = boundary === 'in' ? playhead : clipDrawer.time_start;
      const newEnd = boundary === 'out' ? playhead : clipDrawer.time_end;

      if (newEnd - newStart < 1) {
        notification.showMessage('Clip must be at least one second long.');
        return;
      }
      if (checkOverlap(newStart, newEnd)) {
        return;
      }

      setClipDrawer({
        ...clipDrawer,
        time_start: newStart,
        time_end: newEnd,
      });
      setHasOverlap(false);
    },
    [checkOverlap, clipDrawer, displayPlayedSeconds, notification, videoLengthInSeconds],
  );

  useHotkeys(
    'I',
    (event) => {
      event.preventDefault();
      setClipBoundaryToPlayhead('in');
    },
    { enabled: Boolean(clipDrawer), preventDefault: true },
    [setClipBoundaryToPlayhead],
  );

  useHotkeys(
    'O',
    (event) => {
      event.preventDefault();
      setClipBoundaryToPlayhead('out');
    },
    { enabled: Boolean(clipDrawer), preventDefault: true },
    [setClipBoundaryToPlayhead],
  );

  const handleStartChange = (e: any) => {
    const newStart = Number(e.target.value.replace(/\D/g, ''));
    setClipDrawer({ ...clipDrawer!, time_start: newStart });
    setHasOverlap(checkOverlap(newStart, clipDrawer!.time_end));

    dispatch(updateVideoPlayedSeconds(newStart));
    dispatch(updateTimelineSeconds(newStart));
  };

  const handleEndChange = (e: any) => {
    const newEnd = Number(e.target.value.replace(/\D/g, ''));
    setClipDrawer({ ...clipDrawer!, time_end: newEnd });
    setHasOverlap(checkOverlap(clipDrawer!.time_start, newEnd));

    dispatch(updateVideoPlayedSeconds(newEnd));
    dispatch(updateTimelineSeconds(newEnd));
  };

  const [session, setSession] = useState<TTimelineSession[]>([]);
  const totalClipCount = useMemo(() => videoRows.reduce((sum, row) => sum + (row?.clips?.length || 0), 0), [videoRows]);
  const selectedClipCount = sortedSelectedClips.filter((clip) => !dimmedIds.has(String(clip.id))).length;
  const hasClipSelection = sortedSelectedClips.length > 0 || selectedRows.length > 0;
  const clipCountDisplay = clipFilterActive
    ? waitingForComments ? '…' : hasClipSelection ? selectedClipCount : filteredClipCount
    : selectedClipCount > 0 ? selectedClipCount : totalClipCount;
  const [glowMode, setGlowMode] = useState<'all' | 'selected' | null>(null);
  const [glowActive, setGlowActive] = useState(false);
  const glowTimeoutRef = useRef<number | null>(null);
  const handleClipCountClick = () => {
    if (clipFilterActive) {
      if (waitingForComments || !filteredClipCount) return;
      const clips = videoRows.flatMap((row, rowIndex) => row.clips.map((clip, clipIndex) => ({
        ...clip, rowIndex, clipIndex, topicId: row.id, topicName: row.name,
      }))).filter((clip) => !dimmedIds.has(String(clip.id))).sort(compareTimelineClips);
      setWorkspace('timeline');
      emptySelectedRow();
      dispatch(updateSecondaySelectedClips([]));
      dispatch(updateSortedSelectedClips(clips));
    }
    const hasSelected = clipFilterActive || selectedClipCount > 0;
    setGlowMode(hasSelected ? 'selected' : 'all');
    setGlowActive(true);
    if (glowTimeoutRef.current) {
      window.clearTimeout(glowTimeoutRef.current);
    }
    glowTimeoutRef.current = window.setTimeout(() => {
      setGlowActive(false);
    }, 1000);
  };
  useEffect(() => {
    return () => {
      if (glowTimeoutRef.current) {
        window.clearTimeout(glowTimeoutRef.current);
      }
    };
  }, []);
  const changedTopicIdsRef = useRef<{
    [oldTopicId: number]: { newTopicId: number };
  }>({});

  const rowRefs = useRef<Map<string, HTMLDivElement>>(new Map());
  const [rowDragState, setRowDragState] = useState<TRowDragState>({ dragging: false });
  const rowDragStateRef = useRef<TRowDragState>(rowDragState);
  useEffect(() => {
    rowDragStateRef.current = rowDragState;
  }, [rowDragState]);

  const isRowDragging = rowDragState.dragging && Boolean(rowDragState.rowId);
  const draggedRowId = rowDragState.rowId;

  const rowsForDisplay = useMemo(() => {
    if (!isRowDragging || !draggedRowId) return videoRows;
    return videoRows.filter((row) => row.id !== draggedRowId);
  }, [draggedRowId, isRowDragging, videoRows]);
  const rowIndexById = useMemo(() => new Map(videoRows.map((row, index) => [row.id, index])), [videoRows]);
  const dropLineIndex = isRowDragging ? Math.min(Math.max(rowDragState.targetIndex ?? 0, 0), rowsForDisplay.length) : null;
  const draggedRowName = isRowDragging ? videoRows.find((row) => row.id === draggedRowId)?.name : null;

  const registerRowRef = useCallback((rowId: string, node: HTMLDivElement | null) => {
    if (node) {
      rowRefs.current.set(rowId, node);
    } else {
      rowRefs.current.delete(rowId);
    }
  }, []);

  const handleRowDragMove = useCallback(
    (e: MouseEvent) => {
      const state = rowDragStateRef.current;
      if (!state.dragging || !state.rowId) return;

      const scrollContainer = timelineContentWrapperRef.current;
      if (scrollContainer) {
        const rect = scrollContainer.getBoundingClientRect();
        const edgeThreshold = 64;
        const maxStep = 18;
        let scrollDelta = 0;

        if (e.clientY < rect.top + edgeThreshold) {
          const intensity = (rect.top + edgeThreshold - e.clientY) / edgeThreshold;
          scrollDelta = -Math.ceil(Math.min(1, Math.max(0, intensity)) * maxStep);
        } else if (e.clientY > rect.bottom - edgeThreshold) {
          const intensity = (e.clientY - (rect.bottom - edgeThreshold)) / edgeThreshold;
          scrollDelta = Math.ceil(Math.min(1, Math.max(0, intensity)) * maxStep);
        }

        if (scrollDelta !== 0) {
          scrollContainer.scrollTop += scrollDelta;
        }
      }

      const otherRows = videoRows.filter((row) => row.id !== state.rowId);
      let nextIndex = otherRows.length;
      for (let i = 0; i < otherRows.length; i++) {
        const node = rowRefs.current.get(otherRows[i].id);
        const rect = node?.getBoundingClientRect();
        if (!rect) continue;
        const centerY = rect.top + rect.height / 2;
        if (e.clientY < centerY) {
          nextIndex = i;
          break;
        }
      }
      if (state.targetIndex !== nextIndex) {
        setRowDragState((prev) => ({ ...prev, targetIndex: nextIndex }));
      }
    },
    [videoRows],
  );

  const finishRowDrag = useCallback(async () => {
    const state = rowDragStateRef.current;
    if (!state.dragging) return;
    setRowDragState({ dragging: false });
    document.body.style.cursor = '';
    const { rowId, startIndex, targetIndex } = state;
    if (!rowId || startIndex === undefined || targetIndex === undefined) return;
    const sourceRow = videoRows.find((row) => row.id === rowId);
    if (!sourceRow) return;
    const rowsWithout = videoRows.filter((row) => row.id !== rowId);
    const clampedTarget = Math.max(0, Math.min(rowsWithout.length, targetIndex));
    const reorderedRows = [...rowsWithout.slice(0, clampedTarget), sourceRow, ...rowsWithout.slice(clampedTarget)];
    const newRowIndex = reorderedRows.findIndex((row) => row.id === rowId);
    if (newRowIndex === startIndex) {
      return;
    }
    const previousOrderIds = videoRows.map((row) => row.id);
    const markerSnapshot = { ...markerPosition };
    const wasMarkerOnRow = markerSnapshot.rowIndex === startIndex;
    if (wasMarkerOnRow && newRowIndex !== -1) {
      dispatch(updateMarkerPosition({ ...markerSnapshot, rowIndex: newRowIndex }));
    }
    setVideoRows(reorderedRows);
    if (!feedId) {
      return;
    }
    try {
      await patchReoderComposer(buildReorderPayload(reorderedRows), feedId as string);
      setSession((prev) => [
        ...prev,
        {
          topic: {
            id: rowId,
            name: sourceRow.name,
            status: 'reordered',
            previousOrder: previousOrderIds,
            previousMarkerPosition: wasMarkerOnRow ? markerSnapshot : undefined,
          },
        },
      ]);
    } catch (error: any) {
      setVideoRows(videoRows);
      if (wasMarkerOnRow) {
        dispatch(updateMarkerPosition(markerSnapshot));
      }
      if (error?.response?.data?.message) {
        notification.showMessage(error.response.data.message);
      } else {
        notification.showMessage(NOTIFICATION.SOMETHING_WENT_WRONG);
      }
    }
  }, [dispatch, feedId, markerPosition, notification, setVideoRows, videoRows]);

  useEffect(() => {
    if (!rowDragState.dragging) return;
    const handleMove = (e: MouseEvent) => handleRowDragMove(e);
    const handleUp = () => finishRowDrag();
    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseup', handleUp);
    return () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mouseup', handleUp);
      document.body.style.cursor = '';
    };
  }, [rowDragState.dragging, handleRowDragMove, finishRowDrag]);

  const undoStep = async () => {
    if (loading || undoingFavourite || favouritePending.size) return;
    const lastAction = session[session.length - 1];
    if (lastAction?.favourite) {
      setUndoingFavourite(true);
      try {
        if (await undoFavourites(lastAction.favourite)) {
          setSession((previous) => previous.filter((action) => action !== lastAction));
        }
      } finally {
        setUndoingFavourite(false);
      }
      return;
    }
    setClipDrawer(null);
    setShowColorPicker(false);
    const toDelete = session[session.length - 1];
    if (typeof toDelete !== undefined) {
      try {
        setLoading(true);
        if (toDelete?.clip?.id) {
          let res: any;
          switch (toDelete?.clip?.status) {
            case 'created':
              res = await removeClipForTopic({ ids: [+toDelete.clip.id!] }, +feedId!);
              break;
            case 'deleted':
              if (changedTopicIdsRef?.current?.[toDelete?.clip?.topicId]) {
                toDelete.clip = {
                  ...toDelete.clip,
                  topicId: changedTopicIdsRef.current[toDelete?.clip?.topicId].newTopicId,
                };
              }
              res = await onClipCreate(toDelete.clip);
              break;
            case 'edited':
              const data = await editClip(
                {
                  color: hexToNormalizedRGB(toDelete.clip.color),
                  time_end: +toDelete.clip.time_end,
                  time_start: +toDelete.clip.time_start,
                },
                +toDelete.clip.id!,
              );
              res = data.data;
              break;
            default:
              break;
          }

          if (res) {
            setSession((previous) => {
              return previous.filter((action) => action !== toDelete).map((elem) => {
                if (elem.favourite && res.id != null) {
                  const oldId = String(toDelete?.clip?.id);
                  const newId = String(res.id);
                  return { ...elem, favourite: {
                    ...elem.favourite,
                    clipIds: elem.favourite.clipIds.map((id) => id === oldId ? newId : id),
                    previous: elem.favourite.previous.map((item) => String(item.clipId) === oldId ? { ...item, clipId: Number(newId) } : item),
                  } };
                }
                if (!elem.clip) return elem;

                return {
                  ...elem,
                  clip: {
                    ...elem.clip,
                    id: elem.clip.id === toDelete?.clip?.id ? res.id?.toString() : elem.clip.id,
                  },
                };
              });
            });

            await fetchData(true);
          }
        } else if (toDelete?.topic?.id) {
          let res: any;
          if (toDelete.topic.status === 'reordered') {
            if (feedId && toDelete.topic.previousOrder?.length) {
              const order = toDelete.topic.previousOrder;
              const rowsMap = new Map(videoRows.map((row) => [row.id, row]));
              const reordered = order.map((id) => rowsMap.get(id)).filter((row): row is TRow => Boolean(row));
              const leftovers = videoRows.filter((row) => !order.includes(row.id));
              const finalRows = [...reordered, ...leftovers];
              setVideoRows(finalRows);
              await patchReoderComposer(buildReorderPayload(finalRows), feedId);
              if (toDelete.topic.previousMarkerPosition) {
                dispatch(updateMarkerPosition(toDelete.topic.previousMarkerPosition));
              }
              res = true;
            }
          } else if (toDelete?.topic?.status === 'created') {
            res = await removeTopic({ id: +toDelete.topic.id! }, +feedId!);
          } else if (toDelete.topic.status === 'renamed') {
            if (changedTopicIdsRef?.current?.[toDelete?.topic?.id]) {
              toDelete.topic = {
                ...toDelete.topic,
                id: changedTopicIdsRef.current[toDelete?.topic?.id].newTopicId,
              };
            }
            res = await updateTopicName(toDelete.topic.id, { name: toDelete.topic.name });
          } else {
            res = await createComposerTopic(toDelete.topic.name, feedId!, toDelete.topic.topicIndex || 0, toDelete.topic as TOPIC);
            if (res?.data?.id) {
              changedTopicIdsRef.current = {
                ...changedTopicIdsRef.current,
                [toDelete.topic.id]: {
                  newTopicId: res.data.id,
                },
              };
            }
          }

          setSession((previous) => previous.filter((action) => action !== toDelete));
          setLastSelectedRow('');
          if (res) {
            await fetchData(true);
          }
        }
      } catch (err: any) {
        console.log(err);
        if (err?.response?.data?.message) {
          notification.showMessage(err?.response?.data?.message);
        }
      } finally {
        dispatch(updateNotificationTrigger(Date.now()));
        setLoading(false);
      }
    }
  };

  const handleEditSubmit = async (topic: TRow, name: string) => {
    if (!feedId) return;
    try {
      setLoading(true);

      setSession((previous) => [
        ...previous,
        {
          topic: {
            ...topic,
            status: 'renamed',
          },
        },
      ]);

      await updateTopicName(topic.id, { name });
      enqueueSnackbar(NOTIFICATION.SUCCESSFUL_NAME_CHANGE, {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });
      return await fetchData(true);
    } catch (error) {
      enqueueSnackbar(NOTIFICATION.NOT_EDITED, {
        variant: 'error',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });
    } finally {
      setLoading(false);
    }
  };

  const [showCopyModal, setShowCopyModal] = useState(false);
  const switchCopyModal = () => {
    setShowCopyModal(!showCopyModal);
  };

  useHotkeys(
    'shift + tab',
    (e) => {
      if ((e.target as HTMLElement | null)?.closest('[data-clip-filter-panel]')) return;
      e.preventDefault();
      if (sidebarPlayback.enabled || clipFilterActive || sortedSelectedClips.length) {
        prevTabbedClip();
      }
    },
    [playThisClip, sortedSelectedClips, videoPlayedSeconds, videoControls.playedSeconds, currentPlayingTimelineClip, markerPosition, sidebarPlayback.previous, enterClip,
      clipFilterActive, filteredNavigationClips, seekFilteredClip, stopFilteredPlayback],
  );
  useHotkeys(
    'tab',
    (e) => {
      if ((e.target as HTMLElement | null)?.closest('[data-clip-filter-panel]')) return;
      e.preventDefault();
      if (sidebarPlayback.enabled || clipFilterActive || sortedSelectedClips.length) {
        nextTabbedClip();
      }
    },
    [playThisClip, sortedSelectedClips, videoPlayedSeconds, videoControls.playedSeconds, sidebarPlayback.next, enterClip,
      clipFilterActive, filteredNavigationClips, markerPosition, seekFilteredClip, stopFilteredPlayback],
  );

  const nextTabbedClip = () => {
    if (sidebarPlayback.next()) return;
    if (clipFilterActive) {
      const current = markedClip && displayPlayedSeconds >= markedClip.time_start && displayPlayedSeconds <= markedClip.time_end + 0.5
        ? { ...markedClip, ...markerPosition } : undefined;
      const currentIndex = filteredNavigationClips.findIndex((clip) => current && String(clip.id) === String(current.id));
      const next = currentIndex >= 0 ? filteredNavigationClips[(currentIndex + 1) % filteredNavigationClips.length]
        : filteredNavigationClips.find((clip) => current ? compareTimelineClips(clip, current) > 0 : clip.time_start > displayPlayedSeconds) || filteredNavigationClips[0];
      if (next) seekFilteredClip(next);
      else stopFilteredPlayback();
      return;
    }
    const prevClip = sortedSelectedClips
      .slice()
      .reverse()
      .find((c) => c.time_start <= videoPlayedSeconds);
    if (prevClip) {
      const nextClip = sortedSelectedClips.find((clip) => clip.time_start > prevClip.time_start) || sortedSelectedClips[0];
      if (!nextClip) return;
      enterClip(nextClip.id);
      dispatch(updateTriggerToScroll());
      // @ts-ignore
      dispatch(playNextClipInOrder(prevClip));
      dispatch(toFollowPlayhead(true));
    } else {
      const initialClip = sortedSelectedClips.at(-1);
      if (initialClip) {
        enterClip(sortedSelectedClips[0].id);
        dispatch(updateTriggerToScroll());
        // @ts-ignore
        dispatch(playNextClipInOrder(initialClip));
        dispatch(toFollowPlayhead(true));
      }
    }
  };

  const prevTabbedClip = () => {
    if (sidebarPlayback.previous()) return;
    if (clipFilterActive) {
      const marked = markedClip && displayPlayedSeconds >= markedClip.time_start && displayPlayedSeconds <= markedClip.time_end + 0.5
        ? { ...markedClip, ...markerPosition } : undefined;
      const currentIndex = filteredNavigationClips.findIndex((clip) => marked && String(clip.id) === String(marked.id));
      const current = filteredNavigationClips[currentIndex];
      const previous = current && displayPlayedSeconds > current.time_start + 0.5 ? current
        : currentIndex >= 0 ? filteredNavigationClips[Math.max(0, currentIndex - 1)]
        : filteredNavigationClips.slice().reverse().find((clip) => marked ? compareTimelineClips(clip, marked) < 0 : clip.time_start < displayPlayedSeconds) || filteredNavigationClips[0];
      if (previous) seekFilteredClip(previous);
      else stopFilteredPlayback();
      return;
    }
    const now = videoControls.playedSeconds;
    const topic = videoRows.find((_, rowIndex) => rowIndex === markerPosition.rowIndex);
    console.log(1);
    if (topic) {
      console.log(2);
      const currentClip = topic.clips.find((_, clipIndex) => clipIndex === markerPosition.clipIndex);
      if (currentClip && now > currentClip?.time_start + 0.5) {
        enterClip(currentClip.id);
        console.log(3);
        dispatch(updateTriggerToScroll());
        const nudge = (Math.random() < 0.5 ? -1 : 1) * 1e-10;
        dispatch(updateTimelineSeconds(Math.max(0, currentClip?.time_start + nudge)));
        dispatch(toFollowPlayhead(true));
        dispatch(triggerRefresh());
        return;
      }
    }
    console.log(4);
    const currentIndex = sortedSelectedClips.findIndex((clip) =>
      clip.clipIndex === markerPosition.clipIndex && clip.rowIndex === markerPosition.rowIndex);
    const previousClip = sortedSelectedClips[Math.max(0, currentIndex - 1)];
    if (!previousClip) return;
    enterClip(previousClip.id);
    dispatch(updateTriggerToScroll());
    // @ts-ignore
    dispatch(playPreviousClipInOrder());
    dispatch(toFollowPlayhead(true));
  };

  const contentHistoryCount = session.filter((action) => action.clip || action.topic).length;
  useEffect(() => {
    if (contentHistoryCount) sessionUpdate();
  }, [contentHistoryCount]);

  useHotkeys(
    'J',
    (e) => {
      e.preventDefault();
      scrollToMarker();
    },
    [scrollToMarker],
  );

  useEffect(() => {
    if (zoomAnchorPendingRef.current) {
      const timelineParentScroller = document.getElementById('timeline_parent_scroller');
      if (!timelineParentScroller) {
        zoomAnchorPendingRef.current = false;
        zoomAnchorOffsetRef.current = null;
        return;
      }

      const currentScroll = timelineParentScroller.scrollLeft;
      const fallbackAnchorOffset = timelineParentScroller.offsetWidth / 2 - 200;
      const anchorOffset = zoomAnchorOffsetRef.current ?? fallbackAnchorOffset;
      let nextScroll = markerOffset - anchorOffset;
      const maxScroll = timelineParentScroller.scrollWidth - timelineParentScroller.clientWidth;
      nextScroll = Math.max(0, Math.min(nextScroll, maxScroll));

      if (Math.abs(nextScroll - currentScroll) > 0.5) {
        timelineParentScroller.scrollTo({ left: nextScroll });
      }

      zoomAnchorPendingRef.current = false;
      zoomAnchorOffsetRef.current = null;
      return;
    }

    if (followPlayhead) {
      scrollToMarker();
    }
  }, [zoom, followPlayhead]);

  const isCollaborator =
    parentFolder?.collaborators.some((u) => u.email === currentUser?.email) ||
    !!parentFolder?.group_collaborators.find((g) => g.analysts.find((u) => u.email === currentUser?.email));
  const currentOrgUser =
    currentUser?.organization_users?.find((orgUser) => orgUser.organization?.id === myOrganization?.id) ||
    currentUser?.organization_users?.[0];
  const allowDownloadOwnComposers = currentOrgUser?.allow_download_own_composers ?? true;
  const isViewerOrAnalyst = [RolesLowerCase.VIEWER, RolesLowerCase.ANALYST].includes(currentUser?.role?.title as RolesLowerCase);
  const isOwnMyComposer = currentFeed?.type === VIDEOFEED_TYPE.MY_COMPOSER && currentFeed?.created_by?.id === currentUser?.id;
  const canDownloadOwnMyComposer = !isViewerOrAnalyst || allowDownloadOwnComposers;
  const isOwner = currentFeed?.created_by.id === currentUser?.id;
  const isSharedFeed = !!currentFeed && currentFeed?.created_by?.id !== currentUser?.id;
  const isReadOnlyShared = isSharedFeed && (userAccess === ACCESS_TYPE_ENUM.VIEW || userAccess === ACCESS_TYPE_ENUM.VIEW_AND_COMMENT);
  const canEdit = !isReadOnlyShared && (isOwner || isCollaborator || userAccess === ACCESS_TYPE_ENUM.EDIT_AND_RE_SHARE);
  const canCommentAndCreate = !isReadOnlyShared && userAccess === ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
  const canCommentCreateReshare = !isReadOnlyShared && userAccess === ACCESS_TYPE_ENUM.COMMENT_CREATE_AND_RESHARE;
  const canSendClips = canEdit || canCommentAndCreate || canCommentCreateReshare;
  const canCreateComposerFromContent = canEdit || canCommentAndCreate || canCommentCreateReshare;
  const focusTimeline = useFavouriteEditor({
    rows: videoRows,
    activeClipId: favouriteClipId,
    onFavouritesChange: (favourite) => setSession((previous) => [...previous, { favourite }]),
    select: (clip, additive) => {
      const target = videoRows[clip.rowIndex!]?.clips[clip.clipIndex!];
      if (!target) return;
      if (!additive) setSelectedRows([]);
      setLastSelectedRow('');
      dispatch(updateSortedSelectedClips([...(additive ? sortedSelectedClips : []), {
        ...target, rowIndex: clip.rowIndex!, clipIndex: clip.clipIndex!, topicId: clip.topicId!, topicName: clip.topicName!,
      }].sort((a, b) => a.time_start - b.time_start || a.rowIndex - b.rowIndex || a.clipIndex - b.clipIndex)));
    },
    deselect: (clips) => {
      const removed = Array.isArray(clips) ? clips : [clips];
      const clipIds = new Set(removed.map((clip) => String(clip.id)));
      dispatch(updateSortedSelectedClips(sortedSelectedClips.filter((selected) => !clipIds.has(String(selected.id)))));
    },
    canEdit: !!canEdit,
    canSend: !!canSendClips,
    isPlayheadOverClip: (clip) => displayPlayedSeconds >= clip.time_start && displayPlayedSeconds <= clip.time_end,
    canLockAngle: (clip) => !!currentVideoThatInFrame && (clip.videos?.length ? clip.videos : currentFeed?.videos || [])
      .some((video) => String(video.id) === String(currentVideoThatInFrame.id)),
    setAngleLock: async (clip, locked_angle_id) => {
      if (!canEdit) throw new Error('Clip is read only');
      await setClipAngleLock(clip.id, locked_angle_id);
      setVideoRows((rows) => rows.map((row) => ({ ...row, clips: row.clips.map((item) =>
        String(item.id) === String(clip.id) ? { ...item, locked_angle_id } : item) })));
      dispatch(updateTimelineClipAngleLock({ clipId: clip.id, locked_angle_id }));
      onAngleLockChange(clip.id, locked_angle_id);
    },
    pause: () => dispatch(updateVideoControls({ ...videoControls, playing: false })),
    edit: (clip) => {
      if (!canEdit) return;
      const target = videoRows[clip.rowIndex!]?.clips[clip.clipIndex!];
      if (target) onClipSelect(target, clip.topicId!, clip.rowIndex!, clip.clipIndex!, clip.topicName!, false, true);
      handleEditClip(clip);
    },
    seek: (clip, playing, seconds = clip.time_start) => {
      const target = videoRows[clip.rowIndex!]?.clips[clip.clipIndex!];
      if (!target) return;
      enterClip(clip.id);
      dispatch(updateReachedEnd(false));
      dispatch(toFollowPlayhead(true));
      dispatch(updatePlayThisClip(null));
      dispatch(saveCurrentPlayingTimelineClip({ ...target, ...clip }));
      dispatch(updateTimelineSeconds(seconds));
      dispatch(updateVideoPlayedSeconds(seconds));
      dispatch(imperativeMarkerSetter({ seconds, rowIndex: clip.rowIndex!, clipIndex: clip.clipIndex! }));
      dispatch(updateVideoControls({ ...videoControls, playing, playedSeconds: seconds }));
      dispatch(triggerRefresh());
    },
    send: (clips) => {
      if (!canSendClips || !clips.length) return;
      dispatch(updateOrderedSecondarySelectedClips(clips));
      setSkipConfirmationModals(false);
      switchSendClipModal(true);
    },
  });
  const canDownload =
    currentFeed?.highest_user_access?.allow_downloads ||
    isCollaborator ||
    (currentFeed?.created_by.id === currentUser?.id && (!isOwnMyComposer || canDownloadOwnMyComposer));

  useHotkeys(
    ['s', 'Shift + Control + V', 'Shift + Meta + V'],
    (event) => {
      if (event.repeat) return;
      if (!canSendClips) return;
      if (!sortedSelectedClips.length) {
        if (!currentPlayingTimelineClip) return;
        dispatch(updateSecondaySelectedClips([currentPlayingTimelineClip]));
      } else {
        dispatch(updateSecondaySelectedClips([]));
      }
      setSkipConfirmationModals(false);
      switchSendClipModal(true);
    },
    { ignoreEventWhen: ignoreSendClipShortcut },
    [sortedSelectedClips, currentPlayingTimelineClip, canSendClips, dispatch, switchSendClipModal],
  );

  const handleRowDragStart = useCallback(
    (rowId: string, rowIndex: number, e: React.MouseEvent<HTMLDivElement>) => {
      if (!canEdit) return;
      if (!e.altKey) return;
      e.preventDefault();
      e.stopPropagation();
      setRowDragState({ dragging: true, rowId, startIndex: rowIndex, targetIndex: rowIndex });
      document.body.style.cursor = 'grabbing';
    },
    [canEdit],
  );

  const autoFitOnResizeRef = useRef(true); // controls auto zoomToFit on width change
  const hadZoomToFitRef = useRef(false); // tracks if zoomToFit ever ran
  const lastFitZoomRef = useRef<number | null>(null); // cap for zoom-out

  useEffect(() => {
    const el = divRef.current;
    if (!el) return;

    let prev = el.clientWidth;
    let pendingWidth = prev;
    let animationFrame: number | null = null;
    const ro = new ResizeObserver((entries) => {
      pendingWidth = entries[0].contentRect.width;
      if (animationFrame !== null) return;
      animationFrame = window.requestAnimationFrame(() => {
        animationFrame = null;
        if (pendingWidth === prev) return;
        prev = pendingWidth;
        // Existing behavior: auto-fit when enabled
        if (autoFitOnResizeRef.current) zoomToFitRef.current();

        // NEW: if rows (timeline content) are shorter than the viewport,
        // always zoomToFit, regardless of autoFitOnResizeRef.
        const wrapper = divRef.current;
        const sidebar = timelineRefSidebar.current;
        const content = timelineRef.current; // #actual_timeline
        if (wrapper && sidebar && content) {
          const containerWidth = wrapper.clientWidth - sidebar.clientWidth - 19; // same calc as zoomToFit
          const contentWidth = content.scrollWidth; // total timeline width
          if (contentWidth <= containerWidth) {
            zoomToFitRef.current();
          }
        }
      });
    });

    ro.observe(el);
    return () => {
      if (animationFrame !== null) window.cancelAnimationFrame(animationFrame);
      ro.disconnect();
    };
  }, []);

  return (
    <div
      className={cx(styles.timelineWrapper, collapsed && styles.timelineCollapsed)}
      id="timelineWrapper"
      onPointerDownCapture={focusTimeline}
      style={{
        maxHeight: collapsed || isNarrowScreen ? 'none' : `calc(100vh - ${videoPlayerHeight - 15}px - ${'134px'})`,
      }}
      ref={divRef}
      tabIndex={0}
      onContextMenu={(e) => e.preventDefault()}
    >
      <div className={styles.timelineHeader} id="timeline_head" style={toolbarHidden ? { display: 'none' } : undefined} data-drawing-toolbar-anchor onClick={disablePlayheadFollowerCallback}>
        <div className={styles.timelineHeaderLeftSection}>
          <TimelineButton
            className={styles.mobileControlCenterAction}
            disabled={zoom <= MIN_ZOOM + ZOOM_EPS}
            data-preserve-clip-edit
            onContextMenu={handleZoomIn}
            {...zoomInHandlers}
          >
            <ZoomInIcon />
            Zoom In
          </TimelineButton>
          <TimelineButton
            className={styles.mobileControlCenterAction}
            data-preserve-clip-edit
            onContextMenu={() => {
              autoFitOnResizeRef.current = true;
              zoomToFit();
            }}
            {...zoomOutHandlers}
          >
            <ZoomOutIcon />
            Zoom Out
          </TimelineButton>
          <TimelineButton onClick={switchFullScreen}>
            <FullScreen />
            Full Screen
          </TimelineButton>
          <TimelineButton className={styles.mobileControlCenterAction} onClick={handlePlayPause}>
            {videoControls.playing ? (
              <>
                <PauseIcon /> Pause
              </>
            ) : (
              <>
                <PlayIcon /> Play
              </>
            )}
          </TimelineButton>
          <TimelineButton className={cx(styles.leftSectionBtn, styles.mobileControlCenterAction)}>
            <div className={styles.volumeContainer} onMouseEnter={showVolumeSlider} onMouseLeave={closeVolumeSlider}>
              {showVolume && (
                <div className={styles.volumeSlider}>
                  <Box>
                    <Stack spacing={2} sx={{ mb: 1 }} alignItems="center">
                      <MuiSlider
                        color="secondary"
                        aria-label="Volume"
                        orientation="vertical"
                        value={videoControls.volume * 100}
                        valueLabelDisplay="auto"
                        onChange={handleVolumeChange}
                        sx={{
                          height: 100,
                          zIndex: 1999,
                          '& .MuiSlider-thumb': {
                            display: 'none',
                          },
                        }}
                      />
                    </Stack>
                  </Box>
                </div>
              )}
              <div className={styles.volumeButton}>
                {videoControls.volume > 0 ? (
                  <VolumeIcon onClick={muteSwitch} />
                ) : (
                  <MuteIcon className={styles.muteIcon} onClick={muteSwitch} />
                )}
              </div>
            </div>
            <div onClick={muteSwitch}>Volume</div>
          </TimelineButton>
          <TimelineButton className={styles.leftSectionBtn} onClick={handleClipCountClick}
            disabled={clipFilterActive && (waitingForComments || filteredClipCount === 0)}
            aria-label={clipFilterActive ? `Select all ${filteredClipCount} filtered clips` : 'Highlight clips'}>
            <div className={styles.clipCountLabel}>
              <div className={styles.clipCountNumber}>{clipCountDisplay}</div>
              <div>{clipFilterActive ? hasClipSelection ? 'Selected' : 'Filtered' : selectedClipCount > 0 ? 'Selected' : 'Clips'}</div>
            </div>
          </TimelineButton>
        </div>
        <div className={styles.timelineHeaderRightSection} onClick={disablePlayheadFollowerCallback}>
          <FavouriteStar toolbar />
          {feedData && selectedVideoQuality?.url && (
            <button className={styles.headerBtn} onClick={switchCopyModal}>
              <FileCopyIcon />
              <div>Copy link</div>
            </button>
          )}

          <button id="undo-button" className={styles.headerBtn} onClick={undoStep} disabled={loading || undoingFavourite || favouritePending.size > 0 || session.length === 0}>
            <UndoIcon className={loading || undoingFavourite || favouritePending.size > 0 || session.length === 0 ? styles.undoIconDisabled : styles.undoIconActive} />
            <div>
              Undo
              <br />
              Action{(loading || undoingFavourite) && <LinearProgress />}
            </div>
          </button>

          {canEdit && (
            <>
              <button className={styles.headerBtn} onClick={switchCreateRowModal}>
                <AddClipIcon />
                <div>
                  Add
                  <br />
                  New Row
                </div>
              </button>
              {/* @ts-ignore */}
              <button className={styles.headerBtn} onClick={handleAddClip} disabled={videoRows.length === 0}>
                <AddClipIcon />
                <div>Add Clip</div>
              </button>
            </>
          )}

          {canDownload && (
            <button className={styles.headerBtn} onClick={handleDownloadClick}>
              <DownloadIcon />
              <div>
                Download
                <br />
                <span style={{ opacity: 0 }}>Video</span>
              </div>
            </button>
          )}

          {canEdit && (
            <>
              <button className={styles.headerBtn} onClick={switchUploadJson}>
                <UploadJsonIcon />
                <div>
                  Upload
                  <br />
                  Timeline Data
                </div>
              </button>
              {!currentFeed?.parent_videofeed_id && (
                <button
                  className={styles.headerBtn}
                  onClick={() => setShowCreateEmptyTimelineModal(true)}
                  disabled={creatingEmptyTimeline}
                >
                  <AddClipIcon />
                  <div>
                    Create
                    <br />
                    Empty Timeline
                  </div>
                </button>
              )}
            </>
          )}

          {canSendClips && (
            <button
              className={styles.headerBtn}
              onClick={switchSendClipModal}
              disabled={sortedSelectedClips.length === 0}
            >
              <SendIcon />
              <div>Send Clips</div>
            </button>
          )}

          <button id="notes-switcher" className={styles.headerBtn} onClick={switchNotes}>
            {showNotes ? <ToggleOnOutlinedIcon /> : <ToggleOffOutlinedIcon />}
            <div>
              {showNotes ? 'Hide ' : 'Show '}clips
              <br />
              Information
            </div>
          </button>

          <FilterToolbarButton className={styles.headerBtn} />
          <button className={styles.headerBtn} id="speedOptionMenuRef" onClick={switchSpeedOptionMenu}>
            <div ref={speedOptionMenuRef} className={styles.playbackSelector}>
              <PlaybackSpeed fontSize="small" />
              Playback <br /> Speed
            </div>
          </button>

          {storeSelectedClip?.id && (
            <div className={styles.headerBtn} key={storeSelectedClip.id}>
              <VideoQualitySelector videoData={storeSelectedClip} showLabel />
            </div>
          )}
        </div>
      </div>
      {status === STATUS.LOADING && <LinearProgress />}
      {currentFeed && (
        <UploadJsonModal
          setTriggetForuseEffect={setTriggetForuseEffect}
          open={showJsonModal}
          onFinish={(nextFeedId) => {
            const resolvedFeedId = Number(nextFeedId || currentFeed.id);
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('feedId', String(resolvedFeedId));
            if (
              String(resolvedFeedId) !== String(currentFeed.id) &&
              Number.isFinite(displayPlayedSeconds) &&
              displayPlayedSeconds > 0
            ) {
              currentUrl.searchParams.set('timeToJump', String(displayPlayedSeconds));
            }
            window.history.replaceState({}, '', currentUrl.toString());
            getCurrentVideofeed(resolvedFeedId);
          }}
          switchModal={switchUploadJson}
          videoFeed={currentFeed}
          fetchData={fetchData}
        />
      )}
      {currentFeed && showCreateEmptyTimelineModal && (
        <CreateEmptyTimelineModal
          open
          defaultName={currentFeed.collection_name || currentFeed.title}
          loading={creatingEmptyTimeline}
          onClose={() => setShowCreateEmptyTimelineModal(false)}
          onCreate={createEmptyTimeline}
        />
      )}
      {clipDrawer && (
        <Draggable cancel=".no-drag">
          <div className={styles.modalContainer}>
            <div className={styles.clipDrawerModal} id="clip-drawer-modal" ref={clipDrawerRef}>
              {loading && <LinearProgress />}
              <div className={styles.modalTitle}>
                <div>{clipDrawer.isEdit ? 'Clip editing' : 'Creating a clip'}</div>
                <div ref={clipColorButtonRef} className={cx(styles.chooseColorButton, 'no-drag')} onClick={switchColorPicker}>
                  {' '}
                  <div className={styles.chosenColor} style={{ background: rgbToHex(clipDrawer.color!) }} /> Choose color{' '}
                </div>
                <div className={styles.locateDrawer} onClick={onLocateDrawer}>
                  <Locate fontSize="small" />{' '}
                </div>
              </div>

              <div className={styles.modalInputs}>
                <div className={cx(styles.formattedSecondsStart, 'no-drag')}>{formatSeconds(clipDrawer.time_start)}</div>
                <input
                  className={'no-drag'}
                  value={clipDrawer.time_start.toFixed(0)}
                  type="text"
                  onChange={handleStartChange}
                  onBlur={handleStartBlur}
                />{' '}
                <div className={cx(styles.formattedSeconds, 'no-drag')}>
                  {clipDrawer.time_end - clipDrawer.time_start < 0 ? '00:00' : formatSeconds(clipDrawer.time_end - clipDrawer.time_start)}
                </div>
                <CenterLine className={styles.centerLine} />
                <div className={cx(styles.formattedSecondsEnd, 'no-drag')}>{formatSeconds(clipDrawer.time_end)}</div>
                <input
                  className={'no-drag'}
                  value={clipDrawer.time_end.toFixed(0)}
                  type="text"
                  onChange={handleEndChange}
                  onBlur={handleEndBlur}
                />
              </div>
              <div className={cx(styles.trimToPlayheadButtons, 'no-drag')}>
                <OutlinedButton
                  onClick={() => setClipBoundaryToPlayhead('in')}
                  disabled={displayPlayedSeconds >= clipDrawer.time_end - 1 || displayPlayedSeconds === clipDrawer.time_start}
                >
                  Set In to Playhead <span className={styles.trimShortcut}>I</span>
                </OutlinedButton>
                <OutlinedButton
                  onClick={() => setClipBoundaryToPlayhead('out')}
                  disabled={displayPlayedSeconds <= clipDrawer.time_start + 1 || displayPlayedSeconds === clipDrawer.time_end}
                >
                  Set Out to Playhead <span className={styles.trimShortcut}>O</span>
                </OutlinedButton>
              </div>
              <Popper
                open={showColorPicker}
                anchorEl={clipColorButtonRef.current}
                placement="bottom-end"
                className={styles.colorPickerContainer}
                modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
                data-preserve-clip-edit
                role="dialog"
                aria-label="Choose clip colour"
                onMouseDown={(event) => event.stopPropagation()}
                onTouchStart={(event) => event.stopPropagation()}
              >
                {showColorPicker && (
                  <div className={cx(styles.colorPicker, 'no-drag')}>
                    <ChromePicker
                      disableAlpha={true}
                      color={rgbToHex(clipDrawer.color!)}
                      onChange={(color) => setClipDrawer({ ...clipDrawer, color: color.hex })}
                      // showEditableInput={false}
                    />
                    <div className={styles.colorPickerModalButton}>
                      <OutlinedButton
                        className={styles.btn}
                        onClick={() => {
                          setClipDrawer({ ...clipDrawer, color: initialClipDrawer.color || '#7C7C72' });
                          switchColorPicker();
                        }}
                      >
                        {' '}
                        Cancel{' '}
                      </OutlinedButton>
                      <ContainedButton className={styles.btn} onClick={switchColorPicker}>
                        Save
                      </ContainedButton>
                    </div>
                  </div>
                )}
              </Popper>
              <div className={styles.modalButtons}>
                <div onClick={onCancelDrawerClick} className={styles.resetClipButton}>
                  Reset{' '}
                </div>
                <div className={styles.actionButtons}>
                  <OutlinedButton disabled={loading} onClick={onClipDrawerClose} kind="default">
                    Cancel
                  </OutlinedButton>
                  <ContainedButton onClick={() => onClipCreate()} disabled={loading || hasOverlap}>
                    {clipDrawer.isEdit ? 'Save' : 'Create'}
                  </ContainedButton>
                </div>
              </div>
            </div>
          </div>
        </Draggable>
      )}
      {!collapsed && <FilterSummary />}
      <div
        className={cx(styles.timelineContentWrapper, 'VerticalScroll', clipDrawer?.isEdit && styles.timelineContentWrapperLocked)}
        id={'timeline_parent_scroller'}
        ref={timelineContentWrapperRef}
        onMouseDown={handleTimelineMouseDown}
        onMouseMove={handleManualTimelineMouseMove}
        onWheel={disablePlayheadFollowing}
        onTouchMove={disablePlayheadFollowing}
      >
        <Resizable
          defaultSize={{
            width: rowNameWidth,
            height: '100%',
          }}
          onResizeStop={(e, direction, ref, d) => {
            setRowNameWidth((currentWidth) => {
              const nextWidth = currentWidth + d.width;
              return Math.min(sidebarMaxWidth, Math.max(sidebarMinWidth, nextWidth));
            });
          }}
          onResize={() => {
            if (timelineRefSidebar?.current?.offsetWidth) {
              setNameWidth(Math.max(minNameWidth, timelineRefSidebar?.current?.offsetWidth - nameWidthOffset));
            }
          }}
          minWidth={sidebarMinWidth}
          maxWidth={sidebarMaxWidth}
          style={{
            position: 'sticky',
            height: 'fit-content',
            left: 0,
            zIndex: 50,
            background: 'var(--color-bg-primary)',
          }}
          handleClasses={{
            topRight: 'pointer-events-none',
            top: 'pointer-events-none',
            bottom: 'pointer-events-none',
            bottomRight: 'pointer-events-none',
            bottomLeft: 'pointer-events-none',
            topLeft: 'pointer-events-none',
            left: 'pointer-events-none',
          }}
          enable={{
            right: true,
            top: false,
            bottom: false,
            left: false,
            topRight: false,
            bottomRight: false,
            bottomLeft: false,
            topLeft: false,
          }}
        >
          <div ref={timelineRefSidebar} className={styles.timelineRowLabels}>
            <div className={cx(styles.timelineSidebarRow, styles.timelineSidebarHeader, styles.timelineTime)}>
              <span>{convertSeconds(displayPlayedSeconds)}</span>
              <ContainedButton
                kind="default"
                className={styles.collapseToggle}
                ariaLabel={collapsed ? 'Expand timeline' : 'Collapse timeline'}
                onClick={() => {
                  if (!collapsed) previousScrollTop.current = timelineContentWrapperRef.current?.scrollTop || 0;
                  onToggleCollapse();
                }}
              >
                {collapsed ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                <span>{collapsed ? 'Expand' : 'Collapse'}</span>
              </ContainedButton>
            </div>
            {rowsForDisplay.map((row, rowIndex) => (
              <React.Fragment key={`row-${row.id}`}>
                {dropLineIndex === rowIndex && (
                  <>
                    <div className={styles.dropLine} />
                    {draggedRowName && (
                      <div className={styles.dragPreview}>
                        {' '}
                        <span style={{ marginRight: 20 }}>{rowIndex + 1}</span> {draggedRowName}
                      </div>
                    )}
                  </>
                )}
                <TimelineRowDescription
                  row={row}
                  clipCount={waitingForComments ? '…' : row.clips.filter((clip) => !dimmedIds.has(String(clip.id))).length}
                  collapsed={collapsedRowIds.has(String(row.id)) && String(clipDrawer?.topicId) !== String(row.id)}
                  fetchData={fetchData}
                  setSession={setSession}
                  currentFeed={currentFeed}
                  nameWidth={nameWidth}
                  selectedRows={selectedRows}
                  lastSelectedRow={lastSelectedRow}
                  rowIndex={rowIndexById.get(row.id) ?? rowIndex}
                  onSelectingRow={onSelectingRow}
                  addZeroToNumber={addZeroToNumber}
                  rowNameWidth={rowNameWidth}
                  handleEditSubmit={handleEditSubmit}
                  changedTopicIdsRef={changedTopicIdsRef}
                  isMobile={isNarrowScreen}
                  canEdit={canEdit}
                  rowRef={(node) => registerRowRef(row.id, node)}
                  onRowDragStart={handleRowDragStart}
                />
              </React.Fragment>
            ))}
            {isRowDragging && rowDragState.targetIndex === rowsForDisplay.length && <div className={styles.dropLine} />}
            {isNarrowScreen && isMobileControlCenterOpen && <div className={styles.mobileControlCenterSpacer} />}
          </div>
        </Resizable>
        <div className={cx(styles.timelineScrollbarWrapper, 'CustomScrollbar', 'HorizontalScroll')} id="timeline_viewport">
          <div ref={timelineRef} id="actual_timeline" className={styles.timeline} data-shift-trim={shiftTrim} style={{ width: timelineWidth }}>
            <div className={styles.timelineContentHeader}>
              <CustomSlider
                value={displayPlayedSeconds}
                max={videoLengthInSeconds}
                width={timelineWidth}
                markerHeight={markerHeight - 20}
                onChange={(e, v) => onRulerChange(v, e)}
              />
              <div className={styles.rulerMarks}>
                <TimeMarks seconds={videoLengthInSeconds} zoom={zoom} markMargin={TIMELINE_MARK_MARGIN} />
              </div>
              {clipDrawer?.topicId && (
                <div
                  key={clipDrawer.topicId}
                  className={styles.clipDrawerWrapper}
                  data-clip-drawer-handle
                  style={{
                    left: `${clipDrawer.time_start * zoomedMargin}px`,
                    width: `${(clipDrawer.time_end - clipDrawer.time_start) * zoomedMargin}px`,
                  }}
                >
                  <div
                    style={{ width: clipDrawer?.time_end - clipDrawer.time_start < 10 ? '3px' : '12px' }}
                    className={styles.leftArrow}
                    onMouseDown={(e) => handleMouseDown(e, 'left')}
                  >
                    {clipDrawer?.time_end - clipDrawer.time_start >= 10 && <ChevronLeftIcon style={{ color: 'black', height: '15px' }} />}
                  </div>
                  <div className={styles.centerBar} />
                  <div
                    style={{
                      display: clipDrawer.time_end - clipDrawer.time_start < 10 ? 'block' : 'none',
                      left: '-20px',
                    }}
                    className={styles.smallArrow}
                    onMouseDown={(e) => handleMouseDown(e, 'left')}
                  >
                    <ChevronLeftIcon style={{ color: 'white', height: '15px' }} />
                  </div>
                  <div
                    style={{
                      display: clipDrawer.time_end - clipDrawer.time_start < 10 ? 'block' : 'none',
                      right: '-20px',
                    }}
                    className={styles.smallArrow}
                    onMouseDown={(e) => handleMouseDown(e, 'right')}
                  >
                    <ChevronRightIcon style={{ color: 'white', height: '15px' }} />
                  </div>
                  <div
                    style={{ width: clipDrawer?.time_end - clipDrawer.time_start < 10 ? '3px' : '12px' }}
                    className={styles.rightArrow}
                    onMouseDown={(e) => handleMouseDown(e, 'right')}
                  >
                    {clipDrawer?.time_end - clipDrawer.time_start >= 10 && <ChevronRightIcon style={{ color: 'black', height: '15px' }} />}
                  </div>
                </div>
              )}
            </div>
            <div className={styles.timelineContent} onClick={emptySelectedRow}>
              {rowsForDisplay.map((row, i) => {
                const originalIndex = rowIndexById.get(row.id) ?? i;
                return (
                  <React.Fragment key={`${row.name}_${i}`}>
                    {dropLineIndex === i && (
                      <>
                        <div className={styles.dropLine} style={{ marginBottom: 2, margin: 0 }} />
                        {draggedRowName && <div className={styles.dragPreview}>{draggedRowName}</div>}
                      </>
                    )}
                    <TimelineRow
                      collapsed={collapsedRowIds.has(String(row.id)) && String(clipDrawer?.topicId) !== String(row.id)}
                      dimmedIds={dimmedIds}
                      zoom={zoom}
                      handleEditClip={handleEditClip}
                      onClipEdgeResize={onClipEdgeResize}
                      setSession={setSession}
                      markMargin={TIMELINE_MARK_MARGIN}
                      clips={calculateRowClips(row.clips)}
                      topicName={row.name}
                      onClipSelect={onClipSelect}
                      topicId={row.id}
                      rowIndex={originalIndex}
                      switchCreateOrSendModal={switchCreateOrSendModal}
                      currentFeed={currentFeed}
                      handleEmptySpaceClick={createClipDrawer}
                      clipDrawer={clipDrawer}
                      setClipDrawer={setClipDrawer}
                      emptySelectedRow={emptySelectedRow}
                      changedTopicIdsRef={changedTopicIdsRef}
                      canEdit={canEdit}
                      glowAllClips={glowActive && glowMode === 'all'}
                      glowSelectedClips={glowActive && glowMode === 'selected'}
                      suppressQualifiers={isZooming}
                    />
                  </React.Fragment>
                );
              })}
              {isNarrowScreen && isMobileControlCenterOpen && <div className={styles.mobileControlCenterSpacer} />}
            </div>
          </div>
        </div>
      </div>
      {isNarrowScreen && (
        <MobileControlCenter
          currentTime={displayPlayedSeconds}
          duration={videoLengthInSeconds}
          playing={videoControls.playing}
          muted={videoControls.volume <= 0}
          selectedCount={sortedSelectedClips.length + selectedRows.length}
          onPlayPause={handlePlayPause}
          onMuteToggle={muteSwitch}
          onPreviousClip={prevTabbedClip}
          onNextClip={nextTabbedClip}
          onZoomIn={handleZoomIn}
          onZoomOut={handleZoomOut}
          onSeek={handleMobileSeek}
          onDeselect={handleMobileDeselect}
          onLocatePlayhead={toggleMobileFollowPlayhead}
          onShowComments={onShowComments}
          onOpenChange={setIsMobileControlCenterOpen}
          canSwitchAngle={(feedData?.videos?.length || 0) > 1}
          followPlayhead={followPlayhead}
          zoomInDisabled={zoom <= MIN_ZOOM + ZOOM_EPS}
        />
      )}
      <NewComposerModal
        setSkipConfirmationModals={setSkipConfirmationModals}
        skipConfirmation={skipConfirmationModals}
        open={showConfirmModal}
        switchModal={switchNewComposerModal}
        selectedRows={selectedRows}
        videoRows={videoRows}
      />
      <SendClipModal
        setSkipConfirmationModals={setSkipConfirmationModals}
        skipConfirmation={skipConfirmationModals}
        open={showSendClipModal}
        switchModal={switchSendClipModal}
        onCreateComposer={switchNewComposerModal}
        selectedRows={selectedRows}
        videoRows={videoRows}
        beforeSendToComposer={ensureGeneratedMoviesWarningBeforeSending}
        showCurrentClipChoiceWhenMultipleSelected={true}
        canCreateComposer={canCreateComposerFromContent}
      />
      <CreateOrSendModal
        setSession={setSession}
        open={showCreateOrSendModal}
        handleEditClip={handleEditClip}
        switchModal={switchCreateOrSendModal}
        switchNewComposerModal={switchNewComposerModal}
        switchSendClipModal={switchSendClipModal}
        setSkipConfirmationModals={setSkipConfirmationModals}
        canCreateComposer={canCreateComposerFromContent}
      />
      <CreateRowModal
        open={createRowModal}
        position="top"
        switchModal={switchCreateRowModal}
        createdNewRowCallBack={createdNewRowCallBack}
      />
      <GeneratedMoviesWarningModal
        open={showGeneratedMoviesWarningModal}
        onConfirm={() => resolveGeneratedMoviesWarningModal(true)}
        onClose={() => resolveGeneratedMoviesWarningModal(false)}
      />
      {!!currentFeed && <DownloadDataModal switchModal={switchDownloadDataModal} isOpen={showDownloadModal} feedId={currentFeed.id} />}

      <CopyLinkModal open={showCopyModal} switchModal={switchCopyModal} feedData={feedData} />
    </div>
  );
};

export default Timeline;
